  import React, { useState, useEffect, useRef, useCallback } from 'react';
  import { auth, db } from './firebase';
  import { doc, setDoc, onSnapshot, deleteDoc, updateDoc, increment, getDoc, collection, serverTimestamp, addDoc, query, where, getDocs } from 'firebase/firestore';
  import { Mic, Video, LogOut, Users, Gift, Share2 } from 'lucide-react';
  import AgoraRTC from "agora-rtc-sdk-ng";
  import { useRTCClient } from "agora-rtc-react";
  import { AGORA_APP_ID } from "./agora-config";
  import { enviarNotificacao } from './notificacoesService';
  import { moverSaldo } from './saldoUtilizador';
  import { adicionarXP } from './tabelaNiveis';
  import { getFunctions, httpsCallable } from 'firebase/functions';

  import imagemFundoPainelSalas from './assets/fundos/fundoSalas.png';

  // AS TUAS IMPORTAÇÕES DE ASSETS MANTÊM-SE IGUAIS
// =========================================================================
// IMPORTS DOS STICKERS (Aproveitando as miniaturas dos presentes de futebol)
// =========================================================================

// Grupo 1
import imgSticker90Minutos from './assets/presentes/miniaturas/gift_90_minutos.webp';
import imgStickerAnelCampeao from './assets/presentes/miniaturas/gift_anel_de_campeao.webp';
import imgStickerApito from './assets/presentes/miniaturas/gift_apito.webp';
import imgStickerBaliza from './assets/presentes/miniaturas/gift_baliza.webp';
import imgStickerBancadaVip from './assets/presentes/miniaturas/gift_bancada_vip.webp';

// Grupo 2
import imgStickerBancoSuplentes from './assets/presentes/miniaturas/gift_banco_de_suplentes.webp';
import imgStickerBandeiraClaque from './assets/presentes/miniaturas/gift_bandeira_da_claque.webp';
import imgStickerBandeirolaCanto from './assets/presentes/miniaturas/gift_bandeirola_de_canto.webp';
import imgStickerBolaOuro from './assets/presentes/miniaturas/gift_bola_de_ouro.webp';
import imgStickerBolaChamas from './assets/presentes/miniaturas/gift_bola_em_chamas.webp';

// Grupo 3
import imgStickerBotaDiamante from './assets/presentes/miniaturas/gift_bota_de_diamante.webp';
import imgStickerBrasao from './assets/presentes/miniaturas/gift_brasao.webp';
import imgStickerCachecol from './assets/presentes/miniaturas/gift_cachecol.webp';
import imgStickerCaneleiras from './assets/presentes/miniaturas/gift_caneleiras.webp';
import imgStickerCanhaoCamisolas from './assets/presentes/miniaturas/gift_canhao_de_camisolas.webp';

// Grupo 4
import imgStickerCanhaoConfetes from './assets/presentes/miniaturas/gift_canhao_de_confetes.webp';
import imgStickerCapitao from './assets/presentes/miniaturas/gift_capitao.webp';
import imgStickerCartaoAmarelo from './assets/presentes/miniaturas/gift_cartao_amarelo.webp';
import imgStickerCartaoVermelho from './assets/presentes/miniaturas/gift_cartao_vermelho.webp';
import imgStickerChapeuGuardaRedes from './assets/presentes/miniaturas/gift_chapeu_de_guarda_redes.webp';

// Grupo 5
import imgStickerChuteira from './assets/presentes/miniaturas/gift_chuteira.webp';
import imgStickerChuteirasChamas from './assets/presentes/miniaturas/gift_chuteiras_em_chamas.webp';
import imgStickerCronometro from './assets/presentes/miniaturas/gift_cronometro.webp';
import imgStickerFiscalLinha from './assets/presentes/miniaturas/gift_fiscal_de_linha.webp';
import imgStickerFitasClaque from './assets/presentes/miniaturas/gift_fitas_da_claque.webp';

// Grupo 6
import imgStickerFumoClaque from './assets/presentes/miniaturas/gift_fumo_da_claque.webp';
import imgStickerGorroAdepto from './assets/presentes/miniaturas/gift_gorro_do_adepto.webp';
import imgStickerHallEntrada from './assets/presentes/miniaturas/gift_hall_de_entrada.webp';
import imgStickerHatTrick from './assets/presentes/miniaturas/gift_hat_trick.webp';
import imgStickerHolofotes from './assets/presentes/miniaturas/gift_holofotes.webp';

// Grupo 7
import imgStickerLuvaEspuma from './assets/presentes/miniaturas/gift_luva_de_espuma.webp';
import imgStickerLuvaPlatina from './assets/presentes/miniaturas/gift_luva_de_platina.webp';
import imgStickerLuvasGuardaRedes from './assets/presentes/miniaturas/gift_luvas_de_guarda_redes.webp';
import imgStickerMedalhaCampeao from './assets/presentes/miniaturas/gift_medalha_de_campeao.webp';
import imgStickerMedalhaViceCampeao from './assets/presentes/miniaturas/gift_medalha_de_vice_campeao.webp';

// Grupo 8
import imgStickerMegafone from './assets/presentes/miniaturas/gift_megafone.webp';
import imgStickerMeias from './assets/presentes/miniaturas/gift_meias.webp';
import imgStickerMelhorTreinador from './assets/presentes/miniaturas/gift_melhor_treinador.webp';
import imgStickerMoedaAoAr from './assets/presentes/miniaturas/gift_moeda_ao_ar.webp';
import imgStickerPlacard from './assets/presentes/miniaturas/gift_placard.webp';

// Grupo 9
import imgStickerRelvado from './assets/presentes/miniaturas/gift_relvado.webp';
import imgStickerSprayBarreira from './assets/presentes/miniaturas/gift_spray_de_barreira.webp';
import imgStickerSubstituicao from './assets/presentes/miniaturas/gift_substituicao.webp';
import imgStickerTacaSuprema from './assets/presentes/miniaturas/gift_taca_suprema.webp';
import imgStickerTamborClaque from './assets/presentes/miniaturas/gift_tambor_da_claque.webp';

// Grupo 10
import imgStickerTorresEstadio from './assets/presentes/miniaturas/gift_torres_do_estadio.webp';
import imgStickerTrofeuCampeao from './assets/presentes/miniaturas/gift_trofeu_de_campeao.webp';
import imgStickerTrofeuGuardaRedes from './assets/presentes/miniaturas/gift_trofeu_de_guarda_redes.webp';
import imgStickerVitoria from './assets/presentes/miniaturas/gift_vitoria.webp';
import imgStickerVuvuzela from './assets/presentes/miniaturas/gift_vuvuzela.webp';

// 🎨 TRÊS ARTES DE FUNDO EXCLUSIVAS INTEGRADAS COM ALTA OPACIDADE
import imgFundoAudio from './assets/fundos/fundoAudio.webp';
import imgFundoVideo from './assets/fundos/fundoVideo.webp';
import imgFundoLuckys from './assets/fundos/fundoLuckys.webp';

// IMPORTAÇÃO DOS PRESENTES REAIS
// 1. IMPORTAÇÕES (Tudo em minúsculas como na tua pasta)
// ==========================================
// LISTA MESTRE DE PRESENTES PREMIUM (50 FUTEBOL)
// ==========================================

// Bloco Novos Presentes (Futebol)
// Bloco 1 (150 Moedas)
import imgGift90Minutos from './assets/presentes/miniaturas/gift_90_minutos.webp';
import vidGift90Minutos from './assets/presentes/leves/gift_90_minutos.webm';

import imgGiftAnelCampeao from './assets/presentes/miniaturas/gift_anel_de_campeao.webp';
import vidGiftAnelCampeao from './assets/presentes/leves/gift_anel_de_campeao.webm';

import imgGiftApito from './assets/presentes/miniaturas/gift_apito.webp';
import vidGiftApito from './assets/presentes/leves/gift_apito.webm';

import imgGiftBaliza from './assets/presentes/miniaturas/gift_baliza.webp';
import vidGiftBaliza from './assets/presentes/leves/gift_baliza.webm';

import imgGiftBancadaVip from './assets/presentes/miniaturas/gift_bancada_vip.webp';
import vidGiftBancadaVip from './assets/presentes/leves/gift_bancada_vip.webm';

import imgGiftBancoSuplentes from './assets/presentes/miniaturas/gift_banco_de_suplentes.webp';
import vidGiftBancoSuplentes from './assets/presentes/leves/gift_banco_de_suplentes.webm';

import imgGiftBandeiraClaque from './assets/presentes/miniaturas/gift_bandeira_da_claque.webp';
import vidGiftBandeiraClaque from './assets/presentes/leves/gift_bandeira_da_claque.webm';

import imgGiftBandeirolaCanto from './assets/presentes/miniaturas/gift_bandeirola_de_canto.webp';
import vidGiftBandeirolaCanto from './assets/presentes/leves/gift_bandeirola_de_canto.webm';

import imgGiftBolaOuro from './assets/presentes/miniaturas/gift_bola_de_ouro.webp';
import vidGiftBolaOuro from './assets/presentes/leves/gift_bola_de_ouro.webm';

import imgGiftBolaChamas from './assets/presentes/miniaturas/gift_bola_em_chamas.webp';
import vidGiftBolaChamas from './assets/presentes/leves/gift_bola_em_chamas.webm';

// Bloco Novos Presentes - Grupo 2 (Futebol)
import imgGiftBotaDiamante from './assets/presentes/miniaturas/gift_bota_de_diamante.webp';
import vidGiftBotaDiamante from './assets/presentes/leves/gift_bota_de_diamante.webm';

import imgGiftBrasao from './assets/presentes/miniaturas/gift_brasao.webp';
import vidGiftBrasao from './assets/presentes/leves/gift_brasao.webm';

import imgGiftCachecol from './assets/presentes/miniaturas/gift_cachecol.webp';
import vidGiftCachecol from './assets/presentes/leves/gift_cachecol.webm';

import imgGiftCaneleiras from './assets/presentes/miniaturas/gift_caneleiras.webp';
import vidGiftCaneleiras from './assets/presentes/leves/gift_caneleiras.webm';

import imgGiftCanhaoCamisolas from './assets/presentes/miniaturas/gift_canhao_de_camisolas.webp';
import vidGiftCanhaoCamisolas from './assets/presentes/leves/gift_canhao_de_camisolas.webm';

import imgGiftCanhaoConfetes from './assets/presentes/miniaturas/gift_canhao_de_confetes.webp';
import vidGiftCanhaoConfetes from './assets/presentes/leves/gift_canhao_de_confetes.webm';

import imgGiftCapitao from './assets/presentes/miniaturas/gift_capitao.webp';
import vidGiftCapitao from './assets/presentes/leves/gift_capitao.webm';

import imgGiftCartaoAmarelo from './assets/presentes/miniaturas/gift_cartao_amarelo.webp';
import vidGiftCartaoAmarelo from './assets/presentes/leves/gift_cartao_amarelo.webm';

import imgGiftCartaoVermelho from './assets/presentes/miniaturas/gift_cartao_vermelho.webp';
import vidGiftCartaoVermelho from './assets/presentes/leves/gift_cartao_vermelho.webm';

import imgGiftChapeuGuardaRedes from './assets/presentes/miniaturas/gift_chapeu_de_guarda_redes.webp';
import vidGiftChapeuGuardaRedes from './assets/presentes/leves/gift_chapeu_de_guarda_redes.webm';

// Bloco Novos Presentes - Grupo 3 (Futebol)
import imgGiftChuteira from './assets/presentes/miniaturas/gift_chuteira.webp';
import vidGiftChuteira from './assets/presentes/leves/gift_chuteira.webm';

import imgGiftChuteirasChamas from './assets/presentes/miniaturas/gift_chuteiras_em_chamas.webp';
import vidGiftChuteirasChamas from './assets/presentes/leves/gift_chuteiras_em_chamas.webm';

import imgGiftCronometro from './assets/presentes/miniaturas/gift_cronometro.webp';
import vidGiftCronometro from './assets/presentes/leves/gift_cronometro.webm';

import imgGiftFiscalLinha from './assets/presentes/miniaturas/gift_fiscal_de_linha.webp';
import vidGiftFiscalLinha from './assets/presentes/leves/gift_fiscal_de_linha.webm';

import imgGiftFitasClaque from './assets/presentes/miniaturas/gift_fitas_da_claque.webp';
import vidGiftFitasClaque from './assets/presentes/leves/gift_fitas_da_claque.webm';

import imgGiftFumoClaque from './assets/presentes/miniaturas/gift_fumo_da_claque.webp';
import vidGiftFumoClaque from './assets/presentes/leves/gift_fumo_da_claque.webm';

import imgGiftGorroAdepto from './assets/presentes/miniaturas/gift_gorro_do_adepto.webp';
import vidGiftGorroAdepto from './assets/presentes/leves/gift_gorro_do_adepto.webm';

import imgGiftHallEntrada from './assets/presentes/miniaturas/gift_hall_de_entrada.webp';
import vidGiftHallEntrada from './assets/presentes/leves/gift_hall_de_entrada.webm';

import imgGiftHatTrick from './assets/presentes/miniaturas/gift_hat_trick.webp';
import vidGiftHatTrick from './assets/presentes/leves/gift_hat_trick.webm';

import imgGiftHolofotes from './assets/presentes/miniaturas/gift_holofotes.webp';
import vidGiftHolofotes from './assets/presentes/leves/gift_holofotes.webm';

// Bloco Novos Presentes - Grupo 4 (Futebol)
import imgGiftLuvaEspuma from './assets/presentes/miniaturas/gift_luva_de_espuma.webp';
import vidGiftLuvaEspuma from './assets/presentes/leves/gift_luva_de_espuma.webm';

import imgGiftLuvaPlatina from './assets/presentes/miniaturas/gift_luva_de_platina.webp';
import vidGiftLuvaPlatina from './assets/presentes/leves/gift_luva_de_platina.webm';

import imgGiftLuvasGuardaRedes from './assets/presentes/miniaturas/gift_luvas_de_guarda_redes.webp';
import vidGiftLuvasGuardaRedes from './assets/presentes/leves/gift_luvas_de_guarda_redes.webm';

import imgGiftMedalhaCampeao from './assets/presentes/miniaturas/gift_medalha_de_campeao.webp';
import vidGiftMedalhaCampeao from './assets/presentes/leves/gift_medalha_de_campeao.webm';

import imgGiftMedalhaViceCampeao from './assets/presentes/miniaturas/gift_medalha_de_vice_campeao.webp';
import vidGiftMedalhaViceCampeao from './assets/presentes/leves/gift_medalha_de_vice_campeao.webm';

import imgGiftMegafone from './assets/presentes/miniaturas/gift_megafone.webp';
import vidGiftMegafone from './assets/presentes/leves/gift_megafone.webm';

import imgGiftMeias from './assets/presentes/miniaturas/gift_meias.webp';
import vidGiftMeias from './assets/presentes/leves/gift_meias.webm';

import imgGiftMelhorTreinador from './assets/presentes/miniaturas/gift_melhor_treinador.webp';
import vidGiftMelhorTreinador from './assets/presentes/leves/gift_melhor_treinador.webm';

import imgGiftMoedaAoAr from './assets/presentes/miniaturas/gift_moeda_ao_ar.webp';
import vidGiftMoedaAoAr from './assets/presentes/leves/gift_moeda_ao_ar.webm';

import imgGiftPlacard from './assets/presentes/miniaturas/gift_placard.webp';
import vidGiftPlacard from './assets/presentes/leves/gift_placard.webm';

// Bloco Novos Presentes - Grupo 5 (Futebol - Final)
import imgGiftRelvado from './assets/presentes/miniaturas/gift_relvado.webp';
import vidGiftRelvado from './assets/presentes/leves/gift_relvado.webm';

import imgGiftSprayBarreira from './assets/presentes/miniaturas/gift_spray_de_barreira.webp';
import vidGiftSprayBarreira from './assets/presentes/leves/gift_spray_de_barreira.webm';

import imgGiftSubstituicao from './assets/presentes/miniaturas/gift_substituicao.webp';
import vidGiftSubstituicao from './assets/presentes/leves/gift_substituicao.webm';

import imgGiftTacaSuprema from './assets/presentes/miniaturas/gift_taca_suprema.webp';
import vidGiftTacaSuprema from './assets/presentes/leves/gift_taca_suprema.webm';

import imgGiftTamborClaque from './assets/presentes/miniaturas/gift_tambor_da_claque.webp';
import vidGiftTamborClaque from './assets/presentes/leves/gift_tambor_da_claque.webm';

import imgGiftTorresEstadio from './assets/presentes/miniaturas/gift_torres_do_estadio.webp';
import vidGiftTorresEstadio from './assets/presentes/leves/gift_torres_do_estadio.webm';

import imgGiftTrofeuCampeao from './assets/presentes/miniaturas/gift_trofeu_de_campeao.webp';
import vidGiftTrofeuCampeao from './assets/presentes/leves/gift_trofeu_de_campeao.webm';

import imgGiftTrofeuGuardaRedes from './assets/presentes/miniaturas/gift_trofeu_de_guarda_redes.webp';
import vidGiftTrofeuGuardaRedes from './assets/presentes/leves/gift_trofeu_de_guarda_redes.webm';

import imgGiftVitoria from './assets/presentes/miniaturas/gift_vitoria.webp';
import vidGiftVitoria from './assets/presentes/leves/gift_vitoria.webm';

import imgGiftVuvuzela from './assets/presentes/miniaturas/gift_vuvuzela.webp';
import vidGiftVuvuzela from './assets/presentes/leves/gift_vuvuzela.webm';
import PresenteTransparente from './PresenteTransparente';
import { videoSemFundo } from './presentesSemFundo';
import { useAquecerPresentes } from './useAquecerPresentes';

  const LISTA_REAL = [
  // Patamar 100 Moedas
  { id: 101, nome: '90 Minutos', preco: 100, icone: imgSticker90Minutos },
  { id: 102, nome: 'Anel de Campeão', preco: 100, icone: imgStickerAnelCampeao },
  { id: 103, nome: 'Apito', preco: 100, icone: imgStickerApito },
  { id: 104, nome: 'Baliza', preco: 100, icone: imgStickerBaliza },
  { id: 105, nome: 'Bancada VIP', preco: 100, icone: imgStickerBancadaVip },
  { id: 106, nome: 'Banco de Suplentes', preco: 100, icone: imgStickerBancoSuplentes },
  { id: 107, nome: 'Bandeira da Claque', preco: 100, icone: imgStickerBandeiraClaque },
  { id: 108, nome: 'Bandeirola de Canto', preco: 100, icone: imgStickerBandeirolaCanto },
  { id: 109, nome: 'Bola de Ouro', preco: 100, icone: imgStickerBolaOuro },
  { id: 110, nome: 'Bola em Chamas', preco: 100, icone: imgStickerBolaChamas },

  // Patamar 150 Moedas
  { id: 111, nome: 'Bota de Diamante', preco: 150, icone: imgStickerBotaDiamante },
  { id: 112, nome: 'Brasão', preco: 150, icone: imgStickerBrasao },
  { id: 113, nome: 'Cachecol', preco: 150, icone: imgStickerCachecol },
  { id: 114, nome: 'Caneleiras', preco: 150, icone: imgStickerCaneleiras },
  { id: 115, nome: 'Canhão de Camisolas', preco: 150, icone: imgStickerCanhaoCamisolas },
  { id: 116, nome: 'Canhão de Confetes', preco: 150, icone: imgStickerCanhaoConfetes },
  { id: 117, nome: 'Capitão', preco: 150, icone: imgStickerCapitao },
  { id: 118, nome: 'Cartão Amarelo', preco: 150, icone: imgStickerCartaoAmarelo },
  { id: 119, nome: 'Cartão Vermelho', preco: 150, icone: imgStickerCartaoVermelho },
  { id: 120, nome: 'Chapéu de Guarda-Redes', preco: 150, icone: imgStickerChapeuGuardaRedes },

  // Patamar 250 Moedas
  { id: 121, nome: 'Chuteira', preco: 250, icone: imgStickerChuteira },
  { id: 122, nome: 'Chuteiras em Chamas', preco: 250, icone: imgStickerChuteirasChamas },
  { id: 123, nome: 'Cronómetro', preco: 250, icone: imgStickerCronometro },
  { id: 124, nome: 'Fiscal de Linha', preco: 250, icone: imgStickerFiscalLinha },
  { id: 125, nome: 'Fitas da Claque', preco: 250, icone: imgStickerFitasClaque },
  { id: 126, nome: 'Fumo da Claque', preco: 250, icone: imgStickerFumoClaque },
  { id: 127, nome: 'Gorro do Adepto', preco: 250, icone: imgStickerGorroAdepto },
  { id: 128, nome: 'Hall de Entrada', preco: 250, icone: imgStickerHallEntrada },
  { id: 129, nome: 'Hat-Trick', preco: 250, icone: imgStickerHatTrick },
  { id: 130, nome: 'Holofotes', preco: 250, icone: imgStickerHolofotes },

  // Patamar 400 Moedas
  { id: 131, nome: 'Luva de Espuma', preco: 400, icone: imgStickerLuvaEspuma },
  { id: 132, nome: 'Luva de Platina', preco: 400, icone: imgStickerLuvaPlatina },
  { id: 133, nome: 'Luvas de Guarda-Redes', preco: 400, icone: imgStickerLuvasGuardaRedes },
  { id: 134, nome: 'Medalha de Campeão', preco: 400, icone: imgStickerMedalhaCampeao },
  { id: 135, nome: 'Medalha de Vice-Campeão', preco: 400, icone: imgStickerMedalhaViceCampeao },
  { id: 136, nome: 'Megafone', preco: 400, icone: imgStickerMegafone },
  { id: 137, nome: 'Meias', preco: 400, icone: imgStickerMeias },
  { id: 138, nome: 'Melhor Treinador', preco: 400, icone: imgStickerMelhorTreinador },
  { id: 139, nome: 'Moeda ao Ar', preco: 400, icone: imgStickerMoedaAoAr },
  { id: 140, nome: 'Placard', preco: 400, icone: imgStickerPlacard },

  // Patamar 600 Moedas
  { id: 141, nome: 'Relvado', preco: 600, icone: imgStickerRelvado },
  { id: 142, nome: 'Spray de Barreira', preco: 600, icone: imgStickerSprayBarreira },
  { id: 143, nome: 'Substituição', preco: 600, icone: imgStickerSubstituicao },
  { id: 144, nome: 'Taça Suprema', preco: 600, icone: imgStickerTacaSuprema },
  { id: 145, nome: 'Tambor da Claque', preco: 600, icone: imgStickerTamborClaque },
  { id: 146, nome: 'Torres do Estádio', preco: 600, icone: imgStickerTorresEstadio },
  { id: 147, nome: 'Troféu de Campeão', preco: 600, icone: imgStickerTrofeuCampeao },
  { id: 148, nome: 'Troféu de Guarda-Redes', preco: 600, icone: imgStickerTrofeuGuardaRedes },
  { id: 149, nome: 'Vitória', preco: 600, icone: imgStickerVitoria },
  { id: 150, nome: 'Vuvuzela', preco: 600, icone: imgStickerVuvuzela }
];

const LISTA_PRESENTES = [
  // ==========================================
  // BLOCO 1: 150 MOEDAS
  // ==========================================
  { id: 1, nome: '90 Minutos', preco: 150, icone: imgGift90Minutos, video: vidGift90Minutos },
  { id: 2, nome: 'Anel de Campeão', preco: 150, icone: imgGiftAnelCampeao, video: vidGiftAnelCampeao },
  { id: 3, nome: 'Apito', preco: 150, icone: imgGiftApito, video: vidGiftApito },
  { id: 4, nome: 'Baliza', preco: 150, icone: imgGiftBaliza, video: vidGiftBaliza },
  { id: 5, nome: 'Bancada VIP', preco: 150, icone: imgGiftBancadaVip, video: vidGiftBancadaVip },

  // ==========================================
  // BLOCO 2: 300 MOEDAS
  // ==========================================
  { id: 6, nome: 'Banco de Suplentes', preco: 300, icone: imgGiftBancoSuplentes, video: vidGiftBancoSuplentes },
  { id: 7, nome: 'Bandeira da Claque', preco: 300, icone: imgGiftBandeiraClaque, video: vidGiftBandeiraClaque },
  { id: 8, nome: 'Bandeirola de Canto', preco: 300, icone: imgGiftBandeirolaCanto, video: vidGiftBandeirolaCanto },
  { id: 9, nome: 'Bola de Ouro', preco: 300, icone: imgGiftBolaOuro, video: vidGiftBolaOuro },
  { id: 10, nome: 'Bola em Chamas', preco: 300, icone: imgGiftBolaChamas, video: vidGiftBolaChamas },

  // ==========================================
  // BLOCO 3: 450 MOEDAS
  // ==========================================
  { id: 11, nome: 'Bota de Diamante', preco: 450, icone: imgGiftBotaDiamante, video: vidGiftBotaDiamante },
  { id: 12, nome: 'Brasão', preco: 450, icone: imgGiftBrasao, video: vidGiftBrasao },
  { id: 13, nome: 'Cachecol', preco: 450, icone: imgGiftCachecol, video: vidGiftCachecol },
  { id: 14, nome: 'Caneleiras', preco: 450, icone: imgGiftCaneleiras, video: vidGiftCaneleiras },
  { id: 15, nome: 'Canhão de Camisolas', preco: 450, icone: imgGiftCanhaoCamisolas, video: vidGiftCanhaoCamisolas },

  // ==========================================
  // BLOCO 4: 600 MOEDAS
  // ==========================================
  { id: 16, nome: 'Canhão de Confetes', preco: 600, icone: imgGiftCanhaoConfetes, video: vidGiftCanhaoConfetes },
  { id: 17, nome: 'Capitão', preco: 600, icone: imgGiftCapitao, video: vidGiftCapitao },
  { id: 18, nome: 'Cartão Amarelo', preco: 600, icone: imgGiftCartaoAmarelo, video: vidGiftCartaoAmarelo },
  { id: 19, nome: 'Cartão Vermelho', preco: 600, icone: imgGiftCartaoVermelho, video: vidGiftCartaoVermelho },
  { id: 20, nome: 'Chapéu de Guarda-Redes', preco: 600, icone: imgGiftChapeuGuardaRedes, video: vidGiftChapeuGuardaRedes },

  // ==========================================
  // BLOCO 5: 750 MOEDAS
  // ==========================================
  { id: 21, nome: 'Chuteira', preco: 750, icone: imgGiftChuteira, video: vidGiftChuteira },
  { id: 22, nome: 'Chuteiras em Chamas', preco: 750, icone: imgGiftChuteirasChamas, video: vidGiftChuteirasChamas },
  { id: 23, nome: 'Cronómetro', preco: 750, icone: imgGiftCronometro, video: vidGiftCronometro },
  { id: 24, nome: 'Fiscal de Linha', preco: 750, icone: imgGiftFiscalLinha, video: vidGiftFiscalLinha },
  { id: 25, nome: 'Fitas da Claque', preco: 750, icone: imgGiftFitasClaque, video: vidGiftFitasClaque },

  // ==========================================
  // BLOCO 6: 900 MOEDAS
  // ==========================================
  { id: 26, nome: 'Fumo da Claque', preco: 900, icone: imgGiftFumoClaque, video: vidGiftFumoClaque },
  { id: 27, nome: 'Gorro do Adepto', preco: 900, icone: imgGiftGorroAdepto, video: vidGiftGorroAdepto },
  { id: 28, nome: 'Hall de Entrada', preco: 900, icone: imgGiftHallEntrada, video: vidGiftHallEntrada },
  { id: 29, nome: 'Hat-Trick', preco: 900, icone: imgGiftHatTrick, video: vidGiftHatTrick },
  { id: 30, nome: 'Holofotes', preco: 900, icone: imgGiftHolofotes, video: vidGiftHolofotes },

  // ==========================================
  // BLOCO 7: 1050 MOEDAS
  // ==========================================
  { id: 31, nome: 'Luva de Espuma', preco: 1050, icone: imgGiftLuvaEspuma, video: vidGiftLuvaEspuma },
  { id: 32, nome: 'Luva de Platina', preco: 1050, icone: imgGiftLuvaPlatina, video: vidGiftLuvaPlatina },
  { id: 33, nome: 'Luvas de Guarda-Redes', preco: 1050, icone: imgGiftLuvasGuardaRedes, video: vidGiftLuvasGuardaRedes },
  { id: 34, nome: 'Medalha de Campeão', preco: 1050, icone: imgGiftMedalhaCampeao, video: vidGiftMedalhaCampeao },
  { id: 35, nome: 'Medalha de Vice-Campeão', preco: 1050, icone: imgGiftMedalhaViceCampeao, video: vidGiftMedalhaViceCampeao },

  // ==========================================
  // BLOCO 8: 1200 MOEDAS
  // ==========================================
  { id: 36, nome: 'Megafone', preco: 1200, icone: imgGiftMegafone, video: vidGiftMegafone },
  { id: 37, nome: 'Meias', preco: 1200, icone: imgGiftMeias, video: vidGiftMeias },
  { id: 38, nome: 'Melhor Treinador', preco: 1200, icone: imgGiftMelhorTreinador, video: vidGiftMelhorTreinador },
  { id: 39, nome: 'Moeda ao Ar', preco: 1200, icone: imgGiftMoedaAoAr, video: vidGiftMoedaAoAr },
  { id: 40, nome: 'Placard', preco: 1200, icone: imgGiftPlacard, video: vidGiftPlacard },

  // ==========================================
  // BLOCO 9: 1350 MOEDAS
  // ==========================================
  { id: 41, nome: 'Relvado', preco: 1350, icone: imgGiftRelvado, video: vidGiftRelvado },
  { id: 42, nome: 'Spray de Barreira', preco: 1350, icone: imgGiftSprayBarreira, video: vidGiftSprayBarreira },
  { id: 43, nome: 'Substituição', preco: 1350, icone: imgGiftSubstituicao, video: vidGiftSubstituicao },
  { id: 44, nome: 'Taça Suprema', preco: 1350, icone: imgGiftTacaSuprema, video: vidGiftTacaSuprema },
  { id: 45, nome: 'Tambor da Claque', preco: 1350, icone: imgGiftTamborClaque, video: vidGiftTamborClaque },

  // ==========================================
  // BLOCO 10: 1500 MOEDAS
  // ==========================================
  { id: 46, nome: 'Torres do Estádio', preco: 1500, icone: imgGiftTorresEstadio, video: vidGiftTorresEstadio },
  { id: 47, nome: 'Troféu de Campeão', preco: 1500, icone: imgGiftTrofeuCampeao, video: vidGiftTrofeuCampeao },
  { id: 48, nome: 'Troféu de Guarda-Redes', preco: 1500, icone: imgGiftTrofeuGuardaRedes, video: vidGiftTrofeuGuardaRedes },
  { id: 49, nome: 'Vitória', preco: 1500, icone: imgGiftVitoria, video: vidGiftVitoria },
  { id: 50, nome: 'Vuvuzela', preco: 1500, icone: imgGiftVuvuzela, video: vidGiftVuvuzela }
];

/**
 * ⚡ MOTOR INTELIGENTE DE MULTIPLICADORES LUCKYS (PROTECÇÃO BANCÁRIA - MARGEM 25%)
 * Garante que a PWA nunca fica com prejuízo. Prémios pagos pelo próprio fundo acumulado!
 */
const calcularResultadoLucky = (presenteLucky, fundoReservaDisponivel = 0) => {
  const precoItem = presenteLucky.preco || presenteLucky.custo || 0;
  const semente = Math.floor(Math.random() * 100000) + 1; // Base 100.000 para ler decimais finos
  let multiplicador = 0;

  // LÓGICA 1: CAÇA-JACKPOT 1000X (Exclusivo para o Apito e Capitão)
  if (presenteLucky.selo === 'jackpot_1000x') {
    // 0.096% de probabilidade de dar 1000X -> 96 sementes em 100.000
    if (semente <= 96) {
      multiplicador = 1000; // O JACKPOT SUPREMO!
    } else {
      multiplicador = 0; // 99.904% de probabilidade de PERDER TUDO
    }
  } 
  // LÓGICA 2: RECOMPENSAS REGULARES (Restantes presentes normais das Luckys)
  else {
    // Probabilidades Oficiais Ajustadas do Relatório Mestre
    if (semente <= 60890) {
      multiplicador = 0;   // Perder (0x) -> 60.89%
    } else if (semente <= 82890) {
      multiplicador = 1;   // Retorno (1x) -> 22.00%
    } else if (semente <= 94390) {
      multiplicador = 2;   // Dobro (2x) -> 11.50%
    } else if (semente <= 97390) {
      multiplicador = 5;   // 5x -> 3.00%
    } else if (semente <= 99390) {
      multiplicador = 10;  // 10x -> 2.00%
    } else if (semente <= 99890) {
      multiplicador = 20;  // 20x -> 0.50%
    } else if (semente <= 99990) {
      multiplicador = 50;  // 50x -> 0.10%
    } else {
      multiplicador = 100; // 100x -> 0.01%
    }
  }

  const custoPremioBolas = precoItem * multiplicador;

  // Proteção Bancária: Se o prémio ultrapassar o cofre disponível, força a devolução (1x) ou perda (0x)
  if (multiplicador > 1 && custoPremioBolas > fundoReservaDisponivel) {
    multiplicador = fundoReservaDisponivel >= precoItem ? 1 : 0;
  }

  return {
    multiplicador,
    premioFinalBolas: precoItem * multiplicador,
    ganhou: multiplicador > 0
  };
};

  // ⚡ ARRAY RETIFICADO: 50 LUCKYS COM NOMES 100% EXATOS E FIÉIS AOS ASSETS
const LISTA_LUCKYS = [
  // Nível 1: Equipamentos e Pequenos Acessórios (1 a 25 Bolas)
  { id: 501, nome: 'Apito', preco: 1, icone: new URL('./assets/presentes/miniaturas/lucky_apito.webp', import.meta.url).href, tipo: 'lucky', selo: 'jackpot_1000x' },
  { id: 502, nome: 'Meias', preco: 2, icone: new URL('./assets/presentes/miniaturas/lucky_meias.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 503, nome: 'Caneleiras', preco: 5, icone: new URL('./assets/presentes/miniaturas/lucky_caneleiras.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 504, nome: 'Capitão', preco: 10, icone: new URL('./assets/presentes/miniaturas/lucky_capitao.webp', import.meta.url).href, tipo: 'lucky', selo: 'jackpot_1000x' },
  { id: 505, nome: 'Cronómetro', preco: 10, icone: new URL('./assets/presentes/miniaturas/lucky_cronometro.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 506, nome: '90 Minutos', preco: 12, icone: new URL('./assets/presentes/miniaturas/lucky_90_minutos.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 507, nome: 'Bota de Diamante', preco: 15, icone: new URL('./assets/presentes/miniaturas/lucky_bota_de_diamante.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 508, nome: 'Chapéu de Guarda-Redes', preco: 20, icone: new URL('./assets/presentes/miniaturas/lucky_chapeu_de_guarda_redes.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 509, nome: 'Luvas de Guarda-Redes', preco: 22, icone: new URL('./assets/presentes/miniaturas/lucky_luvas_de_guarda_redes.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 510, nome: 'Chuteira', preco: 25, icone: new URL('./assets/presentes/miniaturas/lucky_chuteira.webp', import.meta.url).href, tipo: 'lucky' },

  // Nível 2: Campo, Estruturas e Arbitragem (30 a 90 Bolas)
    { id: 511, nome: 'Cartão Amarelo', preco: 30, icone: new URL('./assets/presentes/miniaturas/lucky_cartao_amarelo.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 512, nome: 'Cartão Vermelho', preco: 35, icone: new URL('./assets/presentes/miniaturas/lucky_cartao_vermelho.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 513, nome: 'Spray de Barreira', preco: 40, icone: new URL('./assets/presentes/miniaturas/lucky_spray_de_barreira.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 514, nome: 'Bandeirola de Canto', preco: 50, icone: new URL('./assets/presentes/miniaturas/lucky_bandeirola_de_canto.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 515, nome: 'Fiscal de Linha', preco: 55, icone: new URL('./assets/presentes/miniaturas/lucky_fiscal_de_linha.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 516, nome: 'Baliza', preco: 60, icone: new URL('./assets/presentes/miniaturas/lucky_baliza.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 517, nome: 'Relvado', preco: 70, icone: new URL('./assets/presentes/miniaturas/lucky_relvado.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 518, nome: 'Banco de Suplentes', preco: 75, icone: new URL('./assets/presentes/miniaturas/lucky_banco_de_suplentes.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 519, nome: 'Substituição', preco: 80, icone: new URL('./assets/presentes/miniaturas/lucky_substituicao.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 520, nome: 'Hall de Entrada', preco: 90, icone: new URL('./assets/presentes/miniaturas/lucky_hall_de_entrada.webp', import.meta.url).href, tipo: 'lucky' },

  // Nível 3: Festa, Claques e Bancadas (100 a 200 Bolas)
    { id: 521, nome: 'Bancada VIP', preco: 100, icone: new URL('./assets/presentes/miniaturas/lucky_bancada_vip.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 522, nome: 'Torres do Estádio', preco: 110, icone: new URL('./assets/presentes/miniaturas/lucky_torres_do_estadio.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 523, nome: 'Placard', preco: 120, icone: new URL('./assets/presentes/miniaturas/lucky_placard.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 524, nome: 'Holofotes', preco: 130, icone: new URL('./assets/presentes/miniaturas/lucky_holofotes.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 525, nome: 'Gorro de Adepto', preco: 140, icone: new URL('./assets/presentes/miniaturas/lucky_gorro_do_adepto.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 526, nome: 'Vuvuzela', preco: 150, icone: new URL('./assets/presentes/miniaturas/lucky_vuvuzela.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 527, nome: 'Moeda ao Ar', preco: 160, icone: new URL('./assets/presentes/miniaturas/lucky_moeda_ao_ar.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 528, nome: 'Luva de Espuma', preco: 170, icone: new URL('./assets/presentes/miniaturas/lucky_luva_de_espuma.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 529, nome: 'Cachecol', preco: 185, icone: new URL('./assets/presentes/miniaturas/lucky_cachecol.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 530, nome: 'Bandeira da Claque', preco: 200, icone: new URL('./assets/presentes/miniaturas/lucky_bandeira_da_claque.webp', import.meta.url).href, tipo: 'lucky' },

  // Nível 4: Mega Efeitos e Adrenalina em Campo (210 a 350 Bolas)
    { id: 531, nome: 'Fitas da Claque', preco: 210, icone: new URL('./assets/presentes/miniaturas/lucky_fitas_da_claque.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 532, nome: 'Fumo da Claque', preco: 220, icone: new URL('./assets/presentes/miniaturas/lucky_fumo_da_claque.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 533, nome: 'Megafone', preco: 240, icone: new URL('./assets/presentes/miniaturas/lucky_megafone.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 534, nome: 'Canhão de Camisolas', preco: 260, icone: new URL('./assets/presentes/miniaturas/lucky_canhao_de_camisolas.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 535, nome: 'Canhão de Confetes', preco: 280, icone: new URL('./assets/presentes/miniaturas/lucky_canhao_de_confetes.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 536, nome: 'Tambor da Claque', preco: 300, icone: new URL('./assets/presentes/miniaturas/lucky_tambor_da_claque.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 537, nome: 'Chuteiras em Chamas', preco: 320, icone: new URL('./assets/presentes/miniaturas/lucky_chuteiras_em_chamas.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 538, nome: 'Bola em Chamas', preco: 350, icone: new URL('./assets/presentes/miniaturas/lucky_bola_em_chamas.webp', import.meta.url).href, tipo: 'lucky' },

  // Nível 5: Galeria de Troféus Supremos (380 a 500 Bolas)
    { id: 539, nome: 'Hat-Trick', preco: 380, icone: new URL('./assets/presentes/miniaturas/lucky_hat_trick.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 540, nome: 'Medalha de Vice Campeão', preco: 400, icone: new URL('./assets/presentes/miniaturas/lucky_medalha_de_vice_campeao.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 541, nome: 'Medalha de Campeão', preco: 410, icone: new URL('./assets/presentes/miniaturas/lucky_medalha_de_campeao.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 542, nome: 'Melhor Treinador', preco: 420, icone: new URL('./assets/presentes/miniaturas/lucky_melhor_treinador.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 543, nome: 'Troféu de Campeão', preco: 430, icone: new URL('./assets/presentes/miniaturas/lucky_trofeu_de_campeao.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 544, nome: 'Troféu de Guarda-Redes', preco: 440, icone: new URL('./assets/presentes/miniaturas/lucky_trofeu_de_guarda_redes.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 545, nome: 'Luva de Platina', preco: 450, icone: new URL('./assets/presentes/miniaturas/lucky_luva_de_platina.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 546, nome: 'Brasão', preco: 460, icone: new URL('./assets/presentes/miniaturas/lucky_brasao.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 547, nome: 'Anel de Campeão', preco: 470, icone: new URL('./assets/presentes/miniaturas/lucky_anel_de_campeao.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 548, nome: 'Bola de Ouro', preco: 480, icone: new URL('./assets/presentes/miniaturas/lucky_bola_de_ouro.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 549, nome: 'Vitória', preco: 490, icone: new URL('./assets/presentes/miniaturas/lucky_vitoria.webp', import.meta.url).href, tipo: 'lucky' },
  { id: 550, nome: 'Taça Suprema', preco: 500, icone: new URL('./assets/presentes/miniaturas/lucky_taca_suprema.webp', import.meta.url).href, tipo: 'lucky' }
];

// ============================================================================
// PRÉ-CARREGAMENTO DOS MP4 DOS PRESENTES
// ============================================================================
// Um presente em vídeo só "aparece no momento certo" se os primeiros bytes já
// estiverem no telemóvel quando o anúncio chega. Os ficheiros passaram de ~10 MB
// para ~0,5 MB (ver `scripts/otimizar-presentes.mjs`) e ganharam `faststart`,
// mas ainda assim vale a pena aquecer o que se sabe que vai ser preciso:
// o presente que o utilizador acabou de escolher no menu.
//
// O `Set` evita pedir duas vezes o mesmo ficheiro, e os elementos ficam soltos
// (nunca entram no DOM): serve só para o browser guardar a resposta em cache.
const videosJaAquecidos = new Set();

const aquecerVideoPresente = (url) => {
  if (!url || videosJaAquecidos.has(url)) return;
  videosJaAquecidos.add(url);
  try {
    const v = document.createElement('video');
    v.preload = 'auto';
    v.muted = true;
    v.src = url;
    v.load();
  } catch { /* browser sem suporte: o poster trata do resto */ }
};

// Antes o cartão sem foto apontava para "https://gamefutlive.com", que devolve
// uma página HTML e deixava o círculo partido no ecrã de toda a gente.
const FOTO_ADEPTO_PADRAO = "https://cdn-icons-png.flaticon.com/512/5323/5323814.png";

/**
 * ANIMAÇÃO DE PRESENTE EM VÍDEO (MP4 com fundo verde recortado ao vivo)
 *
 * O que estava mal na versão anterior:
 *
 *  • O `<canvas>` procurava o `<video>` com `document.getElementById`. Se a
 *    procura falhasse — e falha sempre que o elemento ainda não está no
 *    documento — o recorte nunca arrancava. Como o `<video>` está em
 *    `display:none`, o único visível é o canvas: resultado, presente invisível.
 *    Agora os dois elementos falam por `ref`, sem depender do DOM global.
 *
 *  • O ecrã ficava vazio enquanto o MP4 descarregava. Com ficheiros de ~10 MB
 *    isso eram vários segundos, e o cronómetro de 4 s do presente muitas vezes
 *    expirava ANTES de o vídeo ter dados para tocar. Agora aparece de imediato
 *    o poster do presente, e o vídeo entra por cima assim que estiver pronto.
 *
 *  • A contagem dos 4 s começava na chegada do presente. Passa a começar quando
 *    o vídeo TOCA, com um tecto absoluto para o caso de nunca chegar a tocar.
 */
// `chave` + `aoTerminar` (a mesma referência em todos os renders) em vez de uma
// arrow criada no JSX do pai: com a arrow, cada render da sala — e a sala
// re-renderiza a cada tap tap, a cada entrada na audiência e a cada mudança de
// saldo — dava um `aoTerminar` novo, o `useEffect` abaixo voltava a correr e o
// vídeo recomeçava do princípio a meio da animação.
const AnimacaoVideoPresente = ({ chave, src, poster, aoTerminar }) => {
  const refCanvas = useRef(null);
  const refVideo = useRef(null);
  const [aTocar, setATocar] = useState(false);

  useEffect(() => {
    const video = refVideo.current;
    const canvas = refCanvas.current;
    if (!video || !canvas) return;

    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    let idFrame = null;
    let relogioFim = null;
    let vivo = true;

    const terminar = () => {
      if (!vivo) return;
      vivo = false;
      aoTerminar(chave);
    };

    const recortarVerde = () => {
      if (!vivo || video.paused || video.ended) return;
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      const imagem = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixeis = imagem.data;
      for (let i = 0; i < pixeis.length; i += 4) {
        const r = pixeis[i], g = pixeis[i + 1], b = pixeis[i + 2];
        if (g > 55 && g > r * 1.15 && g > b * 1.15) pixeis[i + 3] = 0;
      }
      ctx.putImageData(imagem, 0, 0);
      idFrame = requestAnimationFrame(recortarVerde);
    };

    const aoComecar = () => {
      if (!vivo) return;
      setATocar(true);
      
      // 🚀 FORÇA ÁUDIO REAL DE BLOQUEIO DE AUTOPLAY: Volume a 100% e garante desmutado por código
      if (video) {
        video.muted = false;
        video.volume = 1.0;
      }

      if (idFrame === null) idFrame = requestAnimationFrame(recortarVerde);
      if (relogioFim) clearTimeout(relogioFim);
      
      // 🚀 REMOVIDO O TETO DE 6 SEGUNDOS: O vídeo corre agora a sua duração real e total!
      const duracao = Number.isFinite(video.duration) && video.duration > 0
        ? video.duration
        : 5;
      relogioFim = setTimeout(terminar, duracao * 1000 + 250);
    };

    // TECTO ABSOLUTO: se o vídeo nunca chegar a tocar (rede em baixo, codec
    // recusado, autoplay bloqueado), o poster fica 9 s e sai sozinho. Nunca há
    // um presente encravado a tapar o ecrã à espera de um vídeo que não vem.
    const relogioSeguranca = setTimeout(terminar, 9000);

    video.addEventListener('playing', aoComecar);
    video.addEventListener('ended', terminar);
    video.play().catch(() => { /* autoplay recusado: fica o poster */ });

    return () => {
      vivo = false;
      clearTimeout(relogioSeguranca);
      if (relogioFim) clearTimeout(relogioFim);
      if (idFrame !== null) cancelAnimationFrame(idFrame);
      video.removeEventListener('playing', aoComecar);
      video.removeEventListener('ended', terminar);
      try { video.pause(); } catch { /* já estava parado */ }
    };
  }, [src, chave, aoTerminar]);

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 99999,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      pointerEvents: 'none'
    }}>
      <div style={{ position: 'relative', width: '280px', height: '280px' }}>
        {/* O poster segura o lugar até o vídeo pegar. Some assim que ele toca. */}
        {!aTocar && poster && (
          <img
            src={poster}
            alt=""
            style={{
              position: 'absolute', inset: 0, width: '100%', height: '100%',
              objectFit: 'contain',
              filter: 'drop-shadow(0px 0px 12px rgba(57, 255, 20, 0.35))'
            }}
          />
        )}
        <canvas
          ref={refCanvas}
          width={480}
          height={480}
          style={{
            width: '100%', height: '100%', objectFit: 'contain',
            opacity: aTocar ? 1 : 0
          }}
        />
        <video
          ref={refVideo}
          src={src}
          // `preload="auto"` e `playsInline` são o que faz o iPhone começar a
          // descarregar mal o elemento nasce, em vez de esperar pelo play.
          preload="auto"
          autoPlay
          playsInline
          muted={false} volume={1.0}
          style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw', // 🚀 Dá tamanho total para o browser não silenciar o som!
        height: '100vh', // 🚀 Dá tamanho total para o browser não silenciar o som!
        opacity: 0.001, // Quase invisível aos olhos, mas real para o navegador
        pointerEvents: 'none',
        zIndex: -1 // Fica trancado por trás do fundo do estádio sem tapar nada
      }}
        />
      </div>
    </div>
  );
};

/** ANIMAÇÃO DE STICKER (imagem). Vida própria de 4 s, com limpeza garantida. */
const AnimacaoStickerPresente = ({ chave, src, aoTerminar }) => {
  useEffect(() => {
    const relogio = setTimeout(() => aoTerminar(chave), 4000);
    return () => clearTimeout(relogio);
  }, [chave, aoTerminar]);

  return (
    <div style={{
      position: 'fixed', bottom: '100px', left: '50%', transform: 'translateX(-50%)',
      zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center',
      backgroundColor: 'rgba(0,0,0,0.6)', padding: '8px 16px', borderRadius: '16px',
      border: '1px solid rgba(57, 255, 20, 0.3)', pointerEvents: 'none',
      backdropFilter: 'blur(4px)', boxShadow: '0 4px 15px rgba(0,0,0,0.5)'
    }}>
      <img
        src={src}
        alt="Sticker Estádio"
        style={{
          width: '90px', height: '90px', objectFit: 'contain',
          backgroundColor: 'transparent',
          filter: 'drop-shadow(0px 0px 8px rgba(57, 255, 20, 0.4))'
        }}
      />
    </div>
  );
};

  const BancadaSala = ({ aoSair, dadosUtilizador }) => {
    // Põe os vídeos dos presentes a descarregar já, para o primeiro presente não chegar atrasado.
    useAquecerPresentes();
  const [modo, setModo] = useState(null);
  const [audiencia, setAudiencia] = useState(0);
  const [participantes, setParticipantes] = useState(Array(8).fill(null));
  // FILA DE ANIMAÇÕES. Era uma única string (`videoPresenteAtivo`), e por isso
  // um presente só conseguia estar no ecrã de cada vez: o seguinte substituía o
  // anterior e herdava o cronómetro dele. Cada entrada tem agora chave própria.
  const [animacoesAtivas, setAnimacoesAtivas] = useState([]);
  
    const [mostrarMenuDestinatarios, setMostrarMenuDestinatarios] = useState(false);
  const [destinatarioEscolhido, setDestinatarioEscolhido] = useState(null);
  const [dadosDaSala, setDadosDaSala] = useState(null);
  const [microLigado, setMicroLigado] = useState(false);
  const [listaAudiencia, setListaAudiencia] = useState([]);
  const [mostrarLista, setMostrarLista] = useState(false);
  const [listaAvisosFeed, setListaAvisosFeed] = useState([]); // 🚀 FEED TRANSPARENTE ESTILO ALII
    // 🟢 CORREÇÃO 4.2: Controla o ID do utilizador que ganhou o prémio alto para fazer a moldura piscar
  const [uidVencedorNeonAtivo, setUidVencedorNeonAtivo] = useState(null);

  const [avisoPresente, setAvisoPresente] = useState(null);
  const [mostrarSelecaoDestinatario, setMostrarSelecaoDestinatario] = useState(false);
  const [presenteSelecionado, setPresenteSelecionado] = useState(null);

  // ⚡ TRANCAS COMPLEMENTARES PARA O SISTEMA DE LUCKYS E BOLINHA DE REENVIO DO ALII
  const [mostrarMenuLuckys, setMostrarMenuLuckys] = useState(false);
  const [mostrarMenuPresentesNormais, setMostrarMenuPresentesNormais] = useState(false); // Abre os Presentes MP4
  const [mostrarMenuStickers, setMostrarMenuStickers] = useState(false); // 🚀 ATIVADO: Abre os Stickers de Imagem
  const [mostrarCadernetaDono, setMostrarCadernetaDono] = useState(false); // 🍀 NOVO: Controla o Álbum Pessoal do Anfitrião
  const [cromosDesbloqueadosIds, setCromosDesbloqueadosIds] = useState([]);
  const [utilizadorAlvoId, setUtilizadorAlvoId] = useState(null);
  const [tipoMenuAtivo, setTipoMenuAtivo] = useState(""); // "stickers", "luckys" ou "mp4"
  const [quantidadeSelecionada, setQuantidadeSelecionada] = useState(1);
  const [ultimoLuckyEnviado, setUltimoLuckyEnviado] = useState(null);
  const [alvoUltimoLucky, setAlvoUltimoLucky] = useState(null);

  const [totalTapTaps, setTotalTapTaps] = useState(0);
  const [caixaForteBolas, setCaixaForteBolas] = useState(0);  // ⚽ CONTADOR DE BOLAS DA SALA
  const [meuSaldoBolas, setMeuSaldoBolas] = useState(() => dadosUtilizador?.saldoBolas || 0);

  // ⚡ TRANCAS E CRONÓMETRO DO BOTÃO ROSA DE COMBO RÁPIDO (ESTILO ALII)
  const [comboPresenteAtivo, setComboPresenteAtivo] = useState(null);
  const [comboDestinatarioAtivo, setComboDestinatarioAtivo] = useState(null);
  const [contagemComboCliques, setContagemComboCliques] = useState(0);
  const [mostrarBolinhaRosa, setMostrarBolinhaRosa] = useState(false);

  const [idsQueJaSigo, setIdsQueJaSigo] = useState([]);
  const client = useRTCClient();
  const [trackMicrofone, setTrackMicrofone] = useState(null);
  const [trackVideo, setTrackVideo] = useState(null);
  const [cameraLigada, setCameraLigada] = useState(false);
  const meuId = auth.currentUser?.uid;
    // 🚀 TRANCA DE CANAL REAL: Nas salas de áudio, o ID do documento é SEMPRE o UID do Dono (Anfitrião)
  const idCanalRealSala = dadosDaSala?.donoId || auth.currentUser?.uid;

  const larguraEcra = window.innerWidth;
  const raio = larguraEcra * 0.38; 
  const tamanhoBolaDono = larguraEcra * 0.30;
  const tamanhoBolaParticipante = larguraEcra * 0.18;

    // TRANCA SAGRADA DE IDENTIFICAÇÃO DO DONO (BLINDAGEM CONTRA OSCILAÇÃO DE ESTADO)
  const [idDaSalaDestino] = useState(() => dadosUtilizador?.uid || dadosUtilizador?.id || auth.currentUser?.uid);
  const [souDono] = useState(() => auth.currentUser?.uid === idDaSalaDestino);

    useEffect(() => {
    // 🛡️ TRANCA SUPREMA ANTIBANIMENTO (BARREIRA DE SEGURANÇA MUNDIAL)
    if (idDaSalaDestino && meuId && db && !souDono) {
      import('firebase/firestore').then(async ({ doc, getDoc }) => {
        const banDocRef = doc(db, "salas_bancada", idDaSalaDestino, "banidos", meuId);
        const banSnap = await getDoc(banDocRef).catch(() => null);
        
        if (banSnap && banSnap.exists() && banSnap.data()?.banido === true) {
          const siglaBan = (navigator.language || navigator.userLanguage || "pt").toLowerCase().substring(0, 2);
          const avisosBan = {
            pt: "Foste expulso e banido deste estádio! ⚽❌",
            en: "You have been kicked and banned from this stadium! ⚽❌",
            es: "¡Has sido expulsado y baneado de este estadio! ⚽❌",
            fr: "Vous avez été expulsé et banni de ce stade! ⚽❌"
          };
          alert(avisosBan[siglaBan] || avisosBan.en);
          if (typeof aoSair === 'function') aoSair();
          return;
        }
      });
    }

      // Define quem vamos escutar: a pessoa escolhida, o Dono, ou o próprio Dono se abrir a sua Caderneta
    const idParaEscutar = mostrarCadernetaDono ? meuId : (utilizadorAlvoId || idDaSalaDestino);
    
    if (!idParaEscutar || !db) return;
    
    // Antena ligada direto na subcoleção de quem vai receber o presente ou do Álbum do Dono
    const donoCadernetaRef = collection(db, "utilizadores", idParaEscutar, "caderneta_stickers");
    const unsubCaderneta = onSnapshot(donoCadernetaRef, (snapshot) => {
        const desbloqueados = snapshot.docs.map(doc => Number(doc.id));
        setCromosDesbloqueadosIds(desbloqueados);
    }, (err) => console.error("Erro na antena da caderneta da sala:", err));

    return () => unsubCaderneta();
  }, [utilizadorAlvoId, idDaSalaDestino, db, mostrarCadernetaDono, meuId]);

  const alternarMicrofone = async () => {
    try {
      if (!trackMicrofone) {
        // FORÇAR A CRIAÇÃO INDEPENDENTE
        const audioTrack = await AgoraRTC.createMicrophoneAudioTrack({ 
          AEC: true, 
          ANS: true 
        });
        
        // PUBLICAÇÃO MANUAL
        await client.publish(audioTrack);
        audioTrack.stop(); 
        
        setTrackMicrofone(audioTrack);
        setMicroLigado(true);
        console.log("✅ MICROFONE FORÇADO COM SUCESSO");
      } else {
        const novoEstado = !microLigado;
        await trackMicrofone.setEnabled(novoEstado);
        setMicroLigado(novoEstado);
      }
    } catch (e) {
      console.error("ERRO CRÍTICO NO MICROFONE:", e);
      alert("Clica primeiro em 'ATIVAR SONS' e tenta de novo!");
    }
  };

  const alternarCamera = async () => {
    try {
      if (!trackVideo) {
        // Criar a track de vídeo (câmara)
        const videoTrack = await AgoraRTC.createCameraVideoTrack({
          encoderConfig: "720p_1", // Boa qualidade para o círculo
        });
        
        await client.publish(videoTrack);
        
        setTrackVideo(videoTrack);
        setCameraLigada(true);
        console.log("✅ CÂMARA LIGADA COM SUCESSO");
      } else {
        const novoEstado = !cameraLigada;
        await trackVideo.setEnabled(novoEstado);
        setCameraLigada(novoEstado);
      }
    } catch (e) {
      console.error("ERRO NA CÂMARA:", e);
      alert("Não foi possível ligar a câmara. Verifica as permissões!");
    }
  };

  // FUNÇÃO 1: PARA FORÇAR O ÁUDIO A DAR (O tal Botão Mestre)
  const ativarSomGeral = async () => {
    try {
      client.remoteUsers.forEach(async (user) => {
        await client.subscribe(user, "audio");
        user.audioTrack?.play();
      });
      alert("Áudio sincronizado com o Estádio! ⚽");
    } catch (e) { console.error("Erro ao sincronizar:", e); }
  };

  // FUNÇÃO 2: PARA O DONO EXPULSAR ALGUÉM
    // FUNÇÃO DE GESTÃO: Abrir Perfil de quem está na sala
  const gerirUtilizador = (user) => {
    const evento = new CustomEvent('abrirPerfilNaBancada', { 
      detail: { uid: user.uid, nomeCompleto: user.nome, fotoUrl: user.foto } 
    });
    window.dispatchEvent(evento);
    setMostrarLista(false);
  };
  
  const expulsarUtilizador = async (uidAlvo) => {
    if (!souDono) return;
    try {
      // 1. Regista o utilizador na "Lista Negra" da sala
      const banRef = doc(db, "salas_bancada", idDaSalaDestino, "banidos", uidAlvo);
      await setDoc(banRef, { banido: true, data: serverTimestamp() });

      // 2. Remove o utilizador da audiência (isto ativa o sensor que já criámos e chuta-o para fora)
      await deleteDoc(doc(db, "salas_bancada", idDaSalaDestino, "presentes", uidAlvo));
      
      alert("Utilizador banido desta bancada! ⚽🟥");
    } catch (e) { console.error("Erro ao banir:", e); }
  };

  const partilharBancada = async () => {
    try {
          const link = "https://gamefutlive.com"; 
    const texto = `Vem para a Bancada no Estádio! O ${dadosDaSala?.donoNome || "anfitrião"} está ao vivo. Abre a app e clica no teu Sininho de Notificações para entrares direto no círculo! 🏟️⚽`;

      if (navigator.share) {
        await navigator.share({
          title: 'Bancada Real 🏟️',
          text: texto,
          url: link,
        });

              // DISPARO EM MASSA: Notifica seguidores e conexões que a bancada está ao vivo
      try {
        const meuIdAtual = auth.currentUser?.uid;
        if (meuIdAtual) {
          // 1. Procura as conexões na tua coleção de seguidores
                    // 🚀 ALTERADO: Aponta diretamente para as coleções exatas do teu Feed
          const segSnap = await getDocs(query(collection(db, "seguidores"), where("seguindoUid", "==", meuIdAtual)));
          const segDocs = segSnap.docs.map(d => d.data().seguidorUid).filter(Boolean);

          const seguidosSnap = await getDocs(query(collection(db, "seguindo"), where("seguidorUid", "==", meuIdAtual)));
          const seguidosDocs = seguidosSnap.docs.map(d => d.data().seguindoUid).filter(Boolean);

          // Unifica todos os IDs sem duplicar ninguém
          const listaNotificar = [...new Set([...segDocs, ...seguidosDocs])];

          // 2. Dispara o torpedo de notificações dentro da app para cada um
                  // 🔔 Garante o nome real do Dono puxando do Firebase Auth local se o estado da sala falhar
        const meuNome = dadosDaSala?.donoNome || auth.currentUser?.displayName || auth.currentUser?.email?.split('@')[0] || "Um craque";
          for (const uidAlvo of listaNotificar) {
            await enviarNotificacao(
              uidAlvo,
              "Estádio ao Vivo! 🏟️",
              `${meuNome} convidou-te para a sua bancada! Entra e junta-te ao círculo. ⚽`,
              { ecra: "bancada_sala", salaId: idDaSalaDestino }
            );
          }
        }
      } catch (errNotif) {
        console.error("Erro ao disparar notificações em massa da bancada:", errNotif);
      }

      } else {
        alert("Link copiado!");
        navigator.clipboard.writeText(`${texto} ${link}`);
      }
    } catch (e) { console.error("Erro ao partilhar:", e); }
  };

  const processarEnvioPresente = async (presente, destinatario) => {
    // 🚀 Sintoniza rigorosamente no documento real criado pelo Anfitrião
    const idDaSalaDestino = dadosDaSala?.donoId || auth.currentUser?.uid;

    if (!presente || !destinatario || !meuId || !idDaSalaDestino) return;

    try {
      // 🎯 Alinhamento Sagrado: A quantidade a processar e descontar na banca é SEMPRE o tamanho do bloco (ex: pacote de 10)
      const qtdMultiplicador = presente.quantidade || quantidadeSelecionada || 1;
        
      const custoTotalPresenteBolas = presente.preco * qtdMultiplicador;
      
      const meuRef = doc(db, "utilizadores", meuId);
      const meuSnap = await getDoc(meuRef);
      const meuSaldoB = meuSnap.data()?.saldoBolas || 0;

      if (meuSaldoB < custoTotalPresenteBolas) {
        alert("Saldo insuficiente para esta quantidade! ⚽");
        return;
      }

      // 🛡️ TRANCA ANTIFRAUDE: SE FOR STICKER, GERA O DÉBITO SEGURO NO SERVIDOR
      if (presente.tipoPresente === 'sticker' || presente.tipo === 'sticker') {
        try {
          const { getFunctions, httpsCallable } = await import('firebase/functions');
          const functions = getFunctions(undefined, 'europe-west1');
          const chamarStickerSeguro = httpsCallable(functions, 'processarStickerBancadaSeguro');
          
          const resultado = await chamarStickerSeguro({
            salaId: idDaSalaDestino,
            precoBolas: custoTotalPresenteBolas,
            idAnfitriao: destinatario.uid || destinatario.id,
            idDoSticker: presente.id
          });

          if (resultado.data && resultado.data.sucesso) {
            // Atualiza o saldo local na app com o valor real devolvido pelo servidor
            if (typeof setMeuSaldoBolas === 'function' && resultado.data.novoSaldo !== undefined) {
              setMeuSaldoBolas(resultado.data.novoSaldo);
            }
            
            // ========================================================
            // ENVIAR XP AUTOMÁTICO PARA O FIREBASE PARA STICKERS
            // ========================================================
            if (meuId) adicionarXP(meuId, 'adepto', custoTotalPresenteBolas);
            if (destinatario?.uid && destinatario.uid !== meuId) adicionarXP(destinatario.uid, 'jogador', custoTotalPresenteBolas);
            
            // 🔥 PONTE DE ANIMAÇÃO UNIFICADA: Garante que o listener da sala apanha o sticker para desenhar no ecrã
            try {
              const animRef = collection(db, "salas_bancada", idDaSalaDestino, "animacoes_presentes");
              const docAnimacao = await addDoc(animRef, {
                videoUrl: "",
                iconeUrl: presente.icone || presente.url || "",
                posterUrl: presente.icone || presente.url || "",
                presenteNome: presente.nome,
                tipo: "sticker",
                media: presente.icone || presente.url || "",
                ehVideo: false, // Injeta como falso para ativar o teu AnimacaoStickerPresente

                deUid: meuId,
                deNome: auth.currentUser?.displayName || "Adepto",
                deFoto: auth.currentUser?.photoURL || "",
                paraUid: destinatario.uid,
                paraNome: destinatario.nome || "Craque",

                criadoEm: new Date(), // Data nativa para evitar falhas de leitura imediata
                isLucky: false,
                quantidadeCombo: qtdMultiplicador,
                multiplicador: 0,
                totalGanhoBolas: 0,
                ganhouLucky: false
              });

              // Atualiza o documento com a chave única necessária para o motor do React re-renderizar
              await updateDoc(docAnimacao, { id: docAnimacao.id, chave: docAnimacao.id }).catch(() => {});

              // Auto-limpeza do sinal de animação após 25 segundos para manter a subcoleção leve
              setTimeout(() => {
                deleteDoc(docAnimacao).catch(() => {});
              }, 25000);

            } catch (errAnimSticker) {
              console.error("Erro ao injetar sinal de animação do sticker na sala:", errAnimSticker);
            }

            // 🚀 ATIVA A BOLINHA ROSA DE COMBO DE VOLTA PARA O STICKER
            setComboPresenteAtivo(presente);
            setComboDestinatarioAtivo(destinatario);
            const novoValorAcumulado = contagemComboCliques === 0 ? qtdMultiplicador : (contagemComboCliques + qtdMultiplicador);
            setContagemComboCliques(novoValorAcumulado);
            setMostrarBolinhaRosa(true);

            if (window.timerComboBancada) clearTimeout(window.timerComboBancada);
            window.timerComboBancada = setTimeout(() => {
              setMostrarBolinhaRosa(false);
              setContagemComboCliques(0);
            }, 3000);

            setMostrarSelecaoDestinatario(false);

            return; // 🟢 GOLOOO! Salta fora aqui com segurança total!
          }
        } catch (erroCloud) {
          console.error("Erro no servidor do sticker:", erroCloud);
          alert("Erro ao processar o sticker de forma segura. Tenta de novo!");
          return; 
        }
      }

            // 🛡️ TRANCA ANTIFRAUDE: SE FOR VÍDEO, GERA O DÉBITO SEGURO NO SERVIDOR (50/50)
      if (presente.tipo === 'video' || presente.tipoPresente === 'video') {
        try {
          const { getFunctions, httpsCallable } = await import('firebase/functions');
          const functions = getFunctions(undefined, 'europe-west1');
          const chamarVideoSeguro = httpsCallable(functions, 'processarVideoBancadaSeguro');
          
          const resultado = await chamarVideoSeguro({
            salaId: idDaSalaDestino,
            precoBolas: custoTotalPresenteBolas,
            idAnfitriao: destinatario.uid || destinatario.id,
            idDoPresente: presente.id,
            nomePresente: presente.nome,
            videoUrl: presente.video || presente.url || ""
          });

          if (resultado.data && resultado.data.sucesso) {
            // Atualiza o saldo local na app com o valor real devolvido pelo servidor
            if (typeof setMeuSaldoBolas === 'function' && resultado.data.novoSaldo !== undefined) {
              setMeuSaldoBolas(resultado.data.novoSaldo);
            }
            
            // ========================================================
            // ENVIAR XP AUTOMÁTICO PARA O FIREBASE PARA VÍDEOS
            // ========================================================
            if (meuId) adicionarXP(meuId, 'adepto', custoTotalPresenteBolas);
            if (destinatario?.uid && destinatario.uid !== meuId) adicionarXP(destinatario.uid, 'jogador', custoTotalPresenteBolas);
            
            // 🔥 PONTE DE ANIMAÇÃO UNIFICADA: Dispara o sinal de MP4 para a sala toda assistir
            try {
              const animRef = collection(db, "salas_bancada", idDaSalaDestino, "animacoes_presentes");
              const docAnimacao = await addDoc(animRef, {
                videoUrl: presente.video || presente.url || "",
                iconeUrl: presente.icone || "",
                posterUrl: presente.icone || "",
                presenteNome: presente.nome,
                tipo: "video",
                media: presente.video || presente.url || "",
                ehVideo: true, // Ativa a renderização do leitor de vídeo MP4 na sala

                deUid: meuId,
                deNome: auth.currentUser?.displayName || "Adepto",
                deFoto: auth.currentUser?.photoURL || "",
                paraUid: destinatario.uid,
                paraNome: destinatario.nome || "Craque",

                criadoEm: new Date(),
                isLucky: false,
                quantidadeCombo: qtdMultiplicador,
                multiplicador: 0,
                totalGanhoBolas: 0,
                ganhouLucky: false
              });

              await updateDoc(docAnimacao, { id: docAnimacao.id, chave: docAnimacao.id }).catch(() => {});

              setTimeout(() => {
                deleteDoc(docAnimacao).catch(() => {});
              }, 25000);

            } catch (errAnimVideo) {
              console.error("Erro ao injetar sinal de animação do vídeo na sala:", errAnimVideo);
            }

            // 🚀 ATIVA A BOLINHA ROSA DE COMBO PARA O VÍDEO
            setComboPresenteAtivo(presente);
            setComboDestinatarioAtivo(destinatario);
            const novoValorAcumulado = contagemComboCliques === 0 ? qtdMultiplicador : (contagemComboCliques + qtdMultiplicador);
            setContagemComboCliques(novoValorAcumulado);
            setMostrarBolinhaRosa(true);

            if (window.timerComboBancada) clearTimeout(window.timerComboBancada);
            window.timerComboBancada = setTimeout(() => {
              setMostrarBolinhaRosa(false);
              setContagemComboCliques(0);
            }, 3000);

            setMostrarSelecaoDestinatario(false);

            return; // 🟢 GOLOOO! Salta fora aqui com segurança total para não duplicar saldos!
          }
        } catch (erroCloudVideo) {
          console.error("Erro no servidor do presente de vídeo:", erroCloudVideo);
          alert("Erro ao processar o presente de vídeo de forma segura. Tenta de novo!");
          return; 
        }
      }

      let totalPremioBolas = 0;
      let maiorMultiplicadorGanho = 0;
      let vezesGanhou = 0;

      // Loop de combos para luckys migrado para o servidor com Blindagem Máxima
      if (presente.tipo === 'lucky') {
        const { getFunctions, httpsCallable } = await import('firebase/functions');
        const functionsInstance = getFunctions(undefined, 'europe-west1');
        const chamarLuckyNoServidor = httpsCallable(functionsInstance, 'processarLuckySalasSegura');

        try {
          const { getAuth } = await import('firebase/auth');
          const authInstance = getAuth();
          const utilizadorAtual = authInstance.currentUser;
          const tokenDeSeguranca = utilizadorAtual ? await utilizadorAtual.getIdToken(true) : null;

          const respostaServidor = await chamarLuckyNoServidor({
            idDaSalaDestino: idCanalRealSala,
            uidDestinatario: destinatario.uid,
            presenteLucky: presente,
            quantidadeCombo: qtdMultiplicador
          });

          totalPremioBolas = respostaServidor.data.totalPremioBolas;
          maiorMultiplicadorGanho = respostaServidor.data.maiorMultiplicadorGanho;
          vezesGanhou = respostaServidor.data.vezesGanhou;

        } catch (errServidor) {
          alert(errServidor.message || "Erro ao rodar o Lucky.");
          return;
        }
      }

      // Deduz o custo total e injeta o prémio ganho de forma líquida e imediata no jogador
      const bolasParaDeduzir = -custoTotalPresenteBolas + totalPremioBolas;
      const promessaDebito = (presente.tipoPresente === 'sticker' || presente.tipo === 'sticker' || presente.tipo === 'video' || presente.tipoPresente === 'video') ? Promise.resolve() : moverSaldo(meuId, { bolas: bolasParaDeduzir });

      // ========================================================
      // ENVIAR XP AUTOMÁTICO PARA O FIREBASE DIRECTAMENTE DA SALA
      // ========================================================
      if (meuId) {
        adicionarXP(meuId, 'adepto', custoTotalPresenteBolas);
      }
      
      if (destinatario?.uid && destinatario.uid !== meuId) {
        adicionarXP(destinatario.uid, 'jogador', custoTotalPresenteBolas);
      }
      // ========================================================

      if (presente.tipo === 'lucky') {
        console.log("Luckys da bancada processados via Cloud Functions com sucesso.");
      }

    // ============================================================================
// PARTE 2: DISPARA A ANIMAÇÃO PARA A SALA TODA (EXCLUSIVO VÍDEOS MP4 E LUCKYS)
// ============================================================================
      const animRef = collection(db, "salas_bancada", idDaSalaDestino, "animacoes_presentes");
      const docAnimacao = await addDoc(animRef, {
        videoUrl: presente.video || "",
        iconeUrl: presente.icone || "",
        posterUrl: presente.icone || "",
        presenteNome: presente.nome,
        tipo: presente.tipo || presente.tipoPresente || "",
        media: presente.video || presente.icone || presente.url || "", // 🚀 Injeção crucial para anim.media ler o item!
        ehVideo: presente.tipo === 'video' || String(presente.video).endsWith('.mp4'), // 🚀 Identifica se é vídeo ou imagem

        // Identidade Universal 360° ligada aos bancos e microfones flutuantes
                deUid: presente.tipo === 'lucky' ? auth.currentUser?.uid : meuId, // 🚀 Se for Lucky, o emissor real é o UID logado (o jogador)!
        deNome: auth.currentUser?.displayName || "Adepto",
        deFoto: auth.currentUser?.photoURL || "",
        paraUid: presente.tipo === 'lucky' ? meuId : destinatario.uid,
        paraNome: presente.tipo === 'lucky' ? (dadosDaSala?.donoNome || "Anfitrião") : (destinatario.nome || "Craque"),

        criadoEm: serverTimestamp(),
        isLucky: presente.tipo === 'lucky',
        // 🚀 Correção Crítica 4.1: Sincronização em tempo real sem usar objetos window instáveis
        quantidadeCombo: qtdMultiplicador,
        // 🎯 Alinhamento Regulamentar: Se o multiplicador for maior que 0, exibe o prémio real proporcional àquele multiplicador isolado
        multiplicador: maiorMultiplicadorGanho,
        totalGanhoBolas: totalPremioBolas,
        ganhouLucky: totalPremioBolas > 0
      });

      // 🚀 CORREÇÃO 4.2: Atualiza o próprio documento com o ID gerado para alimentar a chave única de re-render do React
      await updateDoc(docAnimacao, { id: docAnimacao.id, chave: docAnimacao.id }).catch(() => {});

      try {
        await promessaDebito;
      } catch (errDebito) {
        console.error("O débito do presente falhou, a retirar o anúncio:", errDebito);
        deleteDoc(docAnimacao).catch(() => {});
        alert("Não foi possível processar o presente. Tenta de novo! ⚽");
        return;
      }

      // 2.1 O ANÚNCIO É DESCARTÁVEL: apaga-se sozinho passados 25 s.
      // Sem isto a subcolecção crescia durante toda a emissão, e quem entrasse a
      // meio recebia o histórico inteiro no primeiro snapshot. Mantendo-a curta,
      // o escutador não precisa de saltar a primeira carga — e era esse salto
      // que, quando o snapshot inicial chegava atrasado, engolia presentes reais.
      setTimeout(() => {
        deleteDoc(docAnimacao).catch(() => { /* já foi limpo por quem saiu */ });
      }, 25000);

      // Distribuição síncrona exclusiva para presentes normais (vídeos MP4)
      if (presente.tipo !== 'lucky' && presente.tipoPresente !== 'sticker' && presente.tipo !== 'sticker') {
        // o streamer(destinatario) recebe sempre os seus 50% em presentes normais
        moverSaldo(destinatario.uid, {
          bolas: custoTotalPresenteBolas * 0.50,
        }).catch(errA => console.error("Erro ao creditar o destinatário:", errA));

        // A tua conta de Administrador Mestre arrecada os 50% organizados rigorosamente
        const meuIdAdminMestre = "wkvSZZR5zdUvweoBuydAept6eOn1";
        const metadeComissaoBolas = custoTotalPresenteBolas * 0.50;

        moverSaldo(meuIdAdminMestre, {
          comissaoPresentesVideoBolas: metadeComissaoBolas
        }).catch(e => console.error("Erro na comissão de Vídeos da Sala:", e));
      }

    // ============================================================================
// PARTE 3: ACUMULADORES, REGISTO DE CADERNETA ADICIONAL E GESTÃO DE COMBOS
// ============================================================================
      // ⚽ ACUMULADOR DE BOLAS DA SALA (Apenas se o Dono receber o presente!)
      if (idDaSalaDestino && destinatario && (destinatario.id === idDaSalaDestino || destinatario.uid === idDaSalaDestino)) {
          updateDoc(doc(db, "salas_bancada", idDaSalaDestino), {
              totalBolasFaturadas: increment(custoTotalPresenteBolas)
          }).catch(errCaixa => console.error("Erro ao somar as Bolas da sala:", errCaixa));
      }

      // 🎫 CARIMBAR CROMO COMO ADQUIRIDO (REDE UNIVERSAL 360°: Donos, Espetadores e Bancada!)
      if (destinatario && (destinatario.id || destinatario.uid)) {
          const idDoRecetorReal = destinatario.id || destinatario.uid;
          
          // Vai buscar o número do cromo (ID - 100)
          const numDoCromo = presente.cromoNumero || (Number(presente.id) - 100);
          
          if (numDoCromo > 0 && numDoCromo <= 50) {
              try {
                  // Grava diretamente na caderneta de QUEM ESTÁ A RECEBER REALMENTE (idDoRecetorReal)
                  await setDoc(doc(db, "utilizadores", idDoRecetorReal, "caderneta_stickers", String(numDoCromo)), {
                      desbloqueado: true,
                      obtidoEm: serverTimestamp()
                  });
                  console.log(`Cromo ${numDoCromo} trancado com sucesso na caderneta do utilizador ${idDoRecetorReal}!`);
              } catch (errUniversalCad) {
                  console.error("Erro ao carimbar cromo na rede universal:", errUniversalCad);
              }
          }
      }

      // Feedback imediato: REMOVIDOS OS ALERTS QUE TRAVAVAM O JOGO!
      if (presente.tipo === 'lucky') {
        if (totalPremioBolas > 0) {
          setAvisoPresente(`⚡ LUCKYS: Rodaste ${qtdMultiplicador}x! O teu maior multiplicador foi de ${maiorMultiplicadorGanho}x. Ganhaste ${totalPremioBolas} ⚽!`);
        } else {
          setAvisoPresente(`⚡ LUCKYS: Rodaste ${qtdMultiplicador}x mas a sorte não esteve contigo! Tenta de novo. 🔥`);
        }
        setQuantidadeSelecionada(1);
      }

      // 🚀 ATIVA A BOLINHA ROSA: Guarda o item e o alvo para abrir o combo rápido
      setComboPresenteAtivo(presente);
      setComboDestinatarioAtivo(destinatario);

      // 🎯 Alinhamento Sagrado: A primeira carga da bolinha assume o valor cheio enviado (ex: 10)
      const tamanhoDoBlocoReal = presente.quantidade || quantidadeSelecionada || 1;
      const novoValorAcumulado = contagemComboCliques === 0 ? tamanhoDoBlocoReal : (contagemComboCliques + tamanhoDoBlocoReal);
      
      setContagemComboCliques(novoValorAcumulado);
      setMostrarBolinhaRosa(true);

      // Limpa e esconde a bolinha após 3 segundos de inatividade usando ref ou o timer padrão limpo
      if (window.timerComboBancada) clearTimeout(window.timerComboBancada);
      window.timerComboBancada = setTimeout(() => {
        setMostrarBolinhaRosa(false);
        setContagemComboCliques(0);
      }, 3000);

      setMostrarSelecaoDestinatario(false);

    } catch (e) { console.error("Erro ao processar envio do presente:", e); }
  };

    // 🛡️ FUNÇÃO AUXILIAR DE SAÍDA DIRETA (MATEI OS ALERTS E WINDOW.CONFIRM QUE CONGELAVAM O ECRA)
  const desocuparLugarMestre = async (index) => {
    try {
      const novosParticipantes = [...participantes];
      novosParticipantes[index] = null; // Liberta o banco na hora no Firebase

      if (trackMicrofone) {
        trackMicrofone.stop();
        trackMicrofone.close();
        setTrackMicrofone(null);
        setMicroLigado(false);
      }
      if (trackVideo) {
        trackVideo.stop();
        trackVideo.close();
        setTrackVideo(null);
        setCameraLigada(false);
      }

      const { doc: fDoc, updateDoc: fUpdateDoc } = await import('firebase/firestore');
      await fUpdateDoc(fDoc(db, "salas_bancada", idDaSalaDestino), { lugares: novosParticipantes });
    } catch (errMestreSair) {
      console.error("Erro no desocupador mestre:", errMestreSair);
    }
  };

  const ocuparLugar = async (index) => {
    if (souDono) return;

    // Se o utilizador já está sentado NESTE banco específico e clica no quadrado, sai sem travar
    if (participantes[index]?.uid === meuId) {
      await desocuparLugarMestre(index);
      return;
    }

    const jaEstaNoutroBanco = participantes.some(p => p?.uid === meuId);
    if (participantes[index] || jaEstaNoutroBanco) return;

    try {
      // 🛑 TRANCA DE SEGURANÇA MESTRE: Verifica se o utilizador está na lista de bloqueados do Dono
      const { doc: fDoc, getDoc: fGetDoc } = await import('firebase/firestore');
      const blocoRef = fDoc(db, "utilizadores", idDaSalaDestino, "bloqueados", meuId);
      const blocoSnap = await fGetDoc(blocoRef);
      
      if (blocoSnap.exists()) {
        alert("Não tens permissão para subir à bancada desta sala! 🟥");
        return;
      }

      const novosParticipantes = [...participantes];
      novosParticipantes[index] = {
        uid: meuId,
        nome: auth.currentUser.displayName || "CRAQUE",
        foto: auth.currentUser.photoURL || ""
      };

      await updateDoc(doc(db, "salas_bancada", idDaSalaDestino), { lugares: novosParticipantes });

      const audioTrack = await AgoraRTC.createMicrophoneAudioTrack({ AEC: true, ANS: true });
      await client.publish(audioTrack);
      audioTrack.stop();
      
      setTrackMicrofone(audioTrack);
      setMicroLigado(true);

    } catch (e) { 
      console.error("Erro ao ocupar lugar:", e);
    }
  };

       // ⚡ ESCUTADOR EM TEMPO REAL DE TAP TAPS DA SALA E SALDO DO UTILIZADOR
  useEffect(() => {
    if (!meuId || !idDaSalaDestino) return;

    // 1. Escuta os Tap Taps da Sala
    const unsubTapsBancada = onSnapshot(doc(db, "salas_bancada", idDaSalaDestino), (salaSnap) => {
      if (salaSnap.exists()) {
        const dados = salaSnap.data();
        setTotalTapTaps(dados?.totalTapTaps || 0);
      }
    });

    // 2. Escuta o Saldo de Bolas do Utilizador Atual em Tempo Real
    const unsubSaldoUsuario = onSnapshot(doc(db, "utilizadores", meuId), (userSnap) => {
      if (userSnap.exists()) {
        const dadosUser = userSnap.data();
        setMeuSaldoBolas(dadosUser?.saldoBolas || 0);
      }
    });

    return () => {
      if (typeof unsubTapsBancada === 'function') unsubTapsBancada();
      if (typeof unsubSaldoUsuario === 'function') unsubSaldoUsuario();
    };
  }, [idDaSalaDestino, meuId]);

  // 🟢 REGISTO, ENTRADA E ESCUTA EM TEMPO REAL DA BANCADA (MÉTODO SUPREMO ANCORADO)
  useEffect(() => {
    if (!meuId || !idDaSalaDestino) return;

        // 1. ARRANQUE SEGURO DE SEGUIDORES (APENAS UMA VEZ) - SINCRONIZADO COM O FEED
    if (!window[`init_arranque_seguidores_${idDaSalaDestino}`]) {
      window[`init_arranque_seguidores_${idDaSalaDestino}`] = true;
      import('firebase/firestore').then(async ({ collection: fColl, getDocs: fGet }) => {
        // 🚀 ALTERADO: Aponta rigorosamente para a subcoleção "seguindo" idêntica à do teu Feed
        const qSeguidos = fColl(db, "utilizadores", meuId, "seguindo");
        const snapSeguidos = await fGet(qSeguidos);
        setIdsQueJaSigo(snapSeguidos.docs.map(d => d.id).filter(Boolean));
      }).catch((err) => console.error("Erro no arranque de seguidos:", err));
    }

    const salaRef = doc(db, "salas_bancada", idDaSalaDestino);
    const audienciaRef = collection(db, "salas_bancada", idDaSalaDestino, "presentes");

    // 2. REGISTO IMEDIATO NA AUDIÊNCIA
    setDoc(doc(audienciaRef, meuId), {
      uid: meuId,
      nome: auth.currentUser?.displayName || "Adepto",
      foto: auth.currentUser?.photoURL || ""
    }).catch(e => console.error("Erro ao registar audiência:", e));

    // 3. ESCUTADOR DA AUDIÊNCIA E SENSOR DE EXPULSÃO
    const unsubAudiencia = onSnapshot(audienciaRef, (snap) => {
      const lista = snap.docs.map(d => d.data());
      setListaAudiencia(lista);
      const euAindaEstouNaLista = lista.some(u => u.uid === meuId);
      if (!souDono && !euAindaEstouNaLista) aoSair();
    });

  // 4. ESCUTADOR VISUAL DA SALA (BLINDAGEM CONTRA LOOPS INFINITOS)
    const unsubSala = onSnapshot(salaRef, (snap) => {
      if (!snap.exists() && !souDono) {
        alert("Esta bancada foi encerrada pelo anfitrião! 🏟️❌");
        aoSair();
        return;
      }
      if (snap.exists()) {
        const data = snap.data();
        setDadosDaSala(data);
        setAudiencia(data.audiencia || 0);
        setParticipantes(data.lugares || Array(8).fill(null));
        
        // ⚽ ACUMULADOR DA SALA: Captura o total de moedas desportivas enviado na bancada
        const totalBolasEnviadas = data?.totalBolasFaturados || data?.totalBolasFaturadas || 0; 
        setCaixaForteBolas(totalBolasEnviadas); // Mostra o valor bruto total cheio!
      }
    });

      // 5. MOTOR DE ÁUDIO/VÍDEO INTERNO BLINDADO CONTRA DUPLAS LIGAÇÕES
    const iniciarAgorartcBancada = async () => {
      // Tranca de segurança contra choques de rede assíncronos
      if (client._isJoined || window.agoraBancadaLigando) {
        console.log("Conexão ao Agora já está ativa ou em progresso. Ignorando duplo clique.");
        return;
      }
      
      try {
        window.agoraBancadaLigando = true;
        try {
          await client.setClientRole("host");
        } catch (errRole) {
          console.warn("Aviso no papel do cliente:", errRole);
        }

        await client.join(AGORA_APP_ID, idDaSalaDestino, null, meuId);
        window.agoraBancadaLigando = false;

        client.on("user-published", async (user, mediaType) => {
          await client.subscribe(user, mediaType);
          if (mediaType === "audio") user.audioTrack?.play();
          if (mediaType === "video") {
            // FIX: Reduzimos o atraso de 1s para o vídeo abrir à velocidade da luz
            const remotePlayerContainer = document.getElementById(user.uid);
            if (remotePlayerContainer) {
              user.videoTrack?.play(remotePlayerContainer);
            } else {
              setTimeout(() => {
                const containerAtrasado = document.getElementById(user.uid);
                if (containerAtrasado) user.videoTrack?.play(containerAtrasado);
              }, 100);
            }
          }
        });

        if (souDono) {
          const audioTrack = await AgoraRTC.createMicrophoneAudioTrack({ AEC: true, ANS: true });
          await client.publish(audioTrack);
          setTrackMicrofone(audioTrack);
          setMicroLigado(true);
        }
      } catch (errAgora) {
        window.agoraBancadaLigando = false;
        console.error("Erro nas faixas do estádio:", errAgora);
      }
    };

    // 6. INICIALIZAÇÃO ASSÍNCRONA DAS COLECÇÕES DO FIREBASE
    const gerirEntradaNoEstadio = async () => {
      if (souDono) {
        if (!modo) return; 
        // Limpa anúncios de emissões anteriores. Antes era um `for` com `await`
        // por documento: com trinta sobras, eram trinta idas ao servidor em
        // fila, e o dono ficava a olhar para o ecrã de arranque durante esse
        // tempo todo. Vão agora todos de uma vez, e sem travar a entrada.
        try {
          const { getDocs: fGetDocs, deleteDoc: fDeleteDoc, collection: fCollection } = await import('firebase/firestore');
          const lixoDocs = await fGetDocs(fCollection(db, "salas_bancada", idDaSalaDestino, "animacoes_presentes"));
          Promise.all(lixoDocs.docs.map((lDoc) => fDeleteDoc(lDoc.ref).catch(() => {})))
            .catch(() => { /* o que sobrar apaga-se sozinho aos 25 s */ });
        } catch (errLixo) { console.error("Erro ao limpar lixo:", errLixo); }

        await setDoc(salaRef, { 
          donoId: meuId, 
          donoNome: (auth.currentUser?.displayName || "ANFITRIÃO").toUpperCase(), 
          donoFoto: auth.currentUser?.photoURL || "", 
          modo: modo, 
          ativa: true, 
          lugares: Array(8).fill(null), 
          audiencia: 1 
        }, { merge: true });

              try {
          // 🚀 ALTERADO: Aponta diretamente para a coleção global de seguidores síncrona com o teu Feed
          const seguidoresSnap = await getDocs(query(collection(db, "seguidores"), where("seguindoUid", "==", meuId)));
          const meuNomeAoVivo = auth.currentUser?.displayName || dadosUtilizador?.nomeCompleto || "Um craque";
          
          for (const segDoc of seguidoresSnap.docs) {
            const seguidorIdReal = segDoc.data().seguidorUid;
            if (seguidorIdReal) {
              await enviarNotificacao(
                seguidorIdReal, 
                "Estádio ao Vivo! 🏟️", 
                `${meuNomeAoVivo} acabou de entrar no Estádio! Junta-te à bancada. ⚽`,
                { ecra: "bancada_sala", salaId: idDaSalaDestino }
              );
            }
          }
        } catch (e) { console.error("Erro nas notificações de arranque da sala:", e); }

        iniciarAgorartcBancada();
      } else {
        getDoc(salaRef).then(snap => {
          if (snap.exists()) {
            const dadosSalaNativa = snap.data();
            setModo(dadosSalaNativa.modo); 
            updateDoc(salaRef, { audiencia: increment(1) });
            iniciarAgorartcBancada();
          } else {
            alert("Esta bancada já não está disponível! 🏟️");
            aoSair();
          }
        }).catch(errVis => console.error("Erro ao carregar como visitante:", errVis));
      }
    };

    gerirEntradaNoEstadio();

    // 7. PROTOCOLO DE DESCONEXÃO E LIMPEZA DE CHOQUE AO SAIR (INTEGRADO CORRETAMENTE)
    return () => {
      unsubAudiencia();
      unsubSala();
      
      if (!souDono && idDaSalaDestino) {
        getDoc(salaRef).then(snap => {
          if (snap.exists()) {
            const lugaresAtuais = snap.data().lugares || Array(8).fill(null);
            const novosLugares = lugaresAtuais.map(p => p?.uid === meuId ? null : p);
            updateDoc(salaRef, { lugares: novosLugares, audiencia: increment(-1) });
          }
        });
      } else if (souDono) {
        deleteDoc(salaRef);
      }

      deleteDoc(doc(db, "salas_bancada", idDaSalaDestino, "presentes", meuId));
      
      if (trackMicrofone) {
        trackMicrofone.stop();
        trackMicrofone.close();
      }
      client.leave();
    };
  }, [meuId, idDaSalaDestino, souDono, modo]);

  // ==========================================================================
  // SENSOR DE PRESENTES — faz o vídeo, o sticker e o cartão aparecerem a TODOS
  // ==========================================================================
  //
  // Três coisas estavam a fazer presentes desaparecerem, e foram as três:
  //
  //  1. A primeira carga do snapshot era descartada inteira (`primeiraCarga`).
  //     A intenção era não repetir o histórico, mas o primeiro snapshot do
  //     Firestore tanto pode ser o da cache como o do servidor: se um presente
  //     chegasse nessa janela, ia fora sem nunca ser mostrado. Agora não há
  //     salto nenhum — o histórico deixou de ser problema porque cada anúncio
  //     se apaga sozinho ao fim de 25 s (ver `processarEnvioPresente`).
  //
  //  2. Havia UMA variável de estado para a animação e UM cronómetro guardado
  //     em `window`. Dois presentes seguidos partilhavam esse cronómetro: o
  //     segundo era apagado do ecrã pelo temporizador que o primeiro tinha
  //     armado. E dois presentes IGUAIS seguidos escreviam a mesma string no
  //     estado, o React não via alteração nenhuma e o vídeo nunca repetia.
  //     Agora é uma fila: cada animação tem chave própria e vida própria.
  //
  //  3. O cronómetro era armado no corpo do render, o que em React 19 corre
  //     mais do que uma vez por atualização. Passou para dentro de cada
  //     animação, num `useEffect` com limpeza a sério.
  const removerAnimacao = useCallback((chave) => {
    setAnimacoesAtivas((atuais) => atuais.filter((a) => a.chave !== chave));
  }, []);

     useEffect(() => {
    // 🚀 BLINDAGEM SUPREMA: Força a sintonização exata na mesma rota de gravação das funções
        const idEfetivoParaEscuta = dadosDaSala?.donoId || auth.currentUser?.uid;
    if (!idEfetivoParaEscuta || !db) return;

    const animRef = collection(db, "salas_bancada", idEfetivoParaEscuta, "animacoes_presentes");
    const jaMostrados = new Set();
    const cronometrosDeCartao = new Set();

    const unsubAnim = onSnapshot(
      animRef,
      (snap) => {
        snap.docChanges().forEach((mudanca) => {
          if (mudanca.type !== "added") return;

          const idDoc = mudanca.doc.id;
          if (jaMostrados.has(idDoc)) return;
          jaMostrados.add(idDoc);

          const dados = mudanca.doc.data() || {};

          // Janela de segurança de tempo contra sobras antigas
          const carimboMs = dados.criadoEm?.toMillis?.() ?? null;
          if (carimboMs !== null && Date.now() - carimboMs > 90000) return;

          // 🚀 CORREÇÃO CRÍTICA 4.2: Deteta as propriedades unificadas de envio
          const media = dados.videoUrl || dados.iconeUrl || "";
          const tipoItem = dados.tipo || "";
          const ehLucky = !!dados.isLucky;

          // ------------------------------------------------ ANIMAÇÃO NO ECRÃ
          // Luckys não desenham animação central (apenas cartão VIP), mas Vídeos e Stickers sim!
          if (media && !ehLucky) {
            const ehVideo = dados.tipo === 'video' || tipoItem === 'mp4' || tipoItem === 'webm' || /\.(mp4|webm|mov)/i.test(String(media));
            const entrada = {
              chave: dados.chave || `${idDoc}_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
              media,
              ehVideo,
              poster: dados.posterUrl || dados.iconeUrl || "",
            };
            
            // Injeta na fila reativa (limite de 3 para performance)
            setAnimacoesAtivas((atuais) => [...atuais, entrada].slice(-3));
          }

          // ----------------------------------------------------- CARTÃO VIP
          const uidRemetente = dados.deUid || dados.uid || idDoc;

                  // 🎯 Correção Crítica 4.1: Sincronização direta com a base de dados eliminando o desfasamento do combo
          const dadosCombo = {
            id: dados.id || idDoc,
            uidRemetente,
            fotoRemetente: dados.deFoto || FOTO_ADEPTO_PADRAO,
            nomeRemetente: dados.deNome || "Craque",
            nomeDestinatario: dados.paraNome || "Bancada",
            presenteIcone: dados.posterUrl || dados.iconeUrl || media,
            presenteNome: dados.presenteNome || "Presente",
            isLucky: ehLucky,
            multiplicadorGanho: Number(dados.multiplicador || 0),
            quantidadeCombo: Number(dados.quantidadeCombo || 1),
            totalGanhoBolas: Number(dados.totalGanhoBolas || 0)
          };

          // 🟢 Correção Crítica 4.2: Se for um prémio alto de Lucky, ativa o flash verde néon no ecrã para toda a gente
          if (ehLucky && Number(dados.multiplicador || 0) > 1) {
            // O prémio pode ter saído para quem enviou ou para quem recebeu. O alvo do flash é o recetor (paraUid)
            const uidAlvoDoFlash = dados.paraUid;
            if (uidAlvoDoFlash) {
              setUidVencedorNeonAtivo(uidAlvoDoFlash);
              
              // Desliga o flash após 2.5 segundos de intermitência visual
              if (window.timerFlashNeonLuckys) clearTimeout(window.timerFlashNeonLuckys);
              window.timerFlashNeonLuckys = setTimeout(() => {
                setUidVencedorNeonAtivo(null);
              }, 2500);
            }
          }

          // Adiciona ao letreiro flutuante néon de combos estilo Alii
          setListaAvisosFeed((prev) => [
            ...prev.filter((item) => item.uidRemetente !== uidRemetente),
            dadosCombo,
          ]);

          const cronometro = setTimeout(() => {
            cronometrosDeCartao.delete(cronometro);
            setListaAvisosFeed((prev) => prev.filter((item) => item.id !== idDoc));
          }, 4000);
          cronometrosDeCartao.add(cronometro);

        const ehVideoMP4 = dados.tipo === 'video' || tipoItem === 'mp4' || tipoItem === 'webm' || /\.(mp4|webm|mov)/i.test(String(media));

          if (!ehLucky && !ehVideoMP4) {
            try {
              const somBomba = new Audio("/sounds/bomba-explosao.mp3");
              somBomba.volume = 1.0;
              somBomba.play().catch(err => console.log("Permissão de áudio pendente:", err));
            } catch (errSom) { console.error("Erro ao tocar áudio da bomba:", errSom); }
          }
        });
      },
      (erro) => console.error("Escutador de presentes interrompido:", erro),
    );

    return () => {
      unsubAnim();
      cronometrosDeCartao.forEach(clearTimeout);
      cronometrosDeCartao.clear();
    };
      }, [dadosDaSala?.donoId, db]);

  // O aviso de texto dos Luckys mantém-se com vida própria, fora do render.
  useEffect(() => {
    if (!avisoPresente) return;
    const relogio = setTimeout(() => setAvisoPresente(null), 4000);
    return () => clearTimeout(relogio);
  }, [avisoPresente]);

  if (!modo && souDono) {
    return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundImage: `url(${imagemFundoPainelSalas})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', zIndex: 99999, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '24px', fontFamily: 'sans-serif' }}>

        {/* TÍTULO PREMIUM COM BRILHO NEON EM EMISSÃO */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px', marginBottom: '10px' }}>
        <span style={{ fontSize: '12px', fontWeight: '900', color: '#39FF14', letterSpacing: '2px', textTransform: 'uppercase', textShadow: '0 0 10px rgba(57,255,20,0.4)' }}>{(navigator.language || navigator.userLanguage).toLowerCase().startsWith('pt') ? "PAINEL DO ANFITRIÃO" : "HOST CONTROL PANEL"}</span>
      <h2 style={{ color: '#FFF', fontSize: '24px', fontWeight: '900', margin: 0, letterSpacing: '1px' }}>{(navigator.language || navigator.userLanguage).toLowerCase().startsWith('pt') ? "ESTÁDIO ABERTO 🏟️" : "OPEN STADIUM 🏟️"}</h2>
        </div>

        {/* CONTAINER DE VIDRO DOS BOTÕES */}
        <div style={{
          background: 'rgba(255, 255, 255, 0.03)',
          backdropFilter: 'blur(16px)',
          WebkitBackdropFilter: 'blur(16px)',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          boxShadow: '0 12px 40px rgba(0, 0, 0, 0.5)',
          borderRadius: '24px',
          padding: '24px 20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          width: '85%',
          maxWidth: '300px',
          boxSizing: 'border-box'
        }}>
          {/* MODO ÁUDIO */}
          <button 
            onClick={() => setModo('voz')} 
            style={{ 
              width: '100%', 
              padding: '16px 20px', 
              background: 'linear-gradient(135deg, #1f122b 0%, #0e0717 100%)', 
              border: '1px solid rgba(123, 0, 255, 0.4)', 
              borderRadius: '16px', 
              fontWeight: '900', 
              fontSize: '14px', 
              color: '#FFF', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              boxShadow: '0 4px 15px rgba(123, 0, 255, 0.15)'
            }}
          >
            <span>🎙️</span> {(navigator.language || navigator.userLanguage).toLowerCase().startsWith('pt') ? "MODO ÁUDIO" : "AUDIO MODE"}
          </button>

          {/* MODO VÍDEO */}
          <button 
            onClick={() => setModo('video')} 
            style={{ 
              width: '100%', 
              padding: '16px 20px', 
              background: 'linear-gradient(135deg, #0b1a10 0%, #040d07 100%)', 
              border: '1px solid rgba(57, 255, 20, 0.3)', 
              borderRadius: '16px', 
              fontWeight: '900', 
              fontSize: '14px', 
              color: '#39FF14', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              boxShadow: '0 4px 15px rgba(57, 255, 20, 0.1)'
            }}
          >
            <span>🎥</span> {(navigator.language || navigator.userLanguage).toLowerCase().startsWith('pt') ? "MODO VÍDEO" : "VIDEO MODE"}
          </button>
          
          {/* MODO LUCKYS VIP */}
          <button 
            onClick={() => setModo('luckys')} 
            style={{ 
              width: '100%', 
              padding: '16px 20px', 
              backgroundColor: '#000', 
              border: '2px solid #FFD700', 
              borderRadius: '16px', 
              fontWeight: '900', 
              fontSize: '14px', 
              color: '#FFD700', 
              boxShadow: '0 0 15px rgba(255, 215, 0, 0.3), inset 0 0 8px rgba(255, 215, 0, 0.1)', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}
          >
            <span>⚡</span> {(navigator.language || navigator.userLanguage).toLowerCase().startsWith('pt') ? "MODO LUCKYS" : "LUCKYS MODE"}
          </button>
        </div>

        <button 
          onClick={aoSair} 
          style={{ 
            marginTop: '10px', 
            color: '#FF4444', 
            background: 'rgba(255, 68, 68, 0.08)', 
            border: '1px solid rgba(255, 68, 68, 0.15)', 
            borderRadius: '12px',
            padding: '8px 20px',
            fontWeight: 'bold', 
            fontSize: '12px',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            cursor: 'pointer' 
          }}
        >
          {(navigator.language || navigator.userLanguage).toLowerCase().startsWith('pt') ? "CANCELAR / SAIR" : "CANCEL / EXIT"}
        </button>
      </div>
    );
  }

    if (!modo && !souDono) {
    return (
      <div style={{ 
        height: '100vh', 
        width: '100vw', 
        backgroundColor: '#020406', // Muro preto sólido instantâneo para tapar o fundo
        background: 'radial-gradient(circle at center, #0a0f18 0%, #020406 100%)', 
        position: 'fixed', // Força a ficar fixo por cima de qualquer outro ecrã da PWA
        top: 0,
        left: 0,
        zIndex: 9999999, // Z-index astronómico para blindar a transição
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        color: '#FFF', 
        fontFamily: 'sans-serif',
        gap: '12px'
      }}>
        <span style={{ fontSize: '28px', animation: 'pulse 1.5s infinite' }}>🏟️</span>
        <span style={{ fontSize: '13px', fontWeight: '900', color: '#39FF14', letterSpacing: '2px', textTransform: 'uppercase', textShadow: '0 0 8px rgba(57,255,20,0.3)' }}>
          A ENTRAR NO ESTÁDIO...
        </span>
      </div>
    );
  }

      {/* LÓGICA DO FUNDO PREMIUM COM AS TUAS ARTES LOCAIS 100% LIMPAS (ESTILO ALII) */}
  const obterFundoDaSala = () => {
    if (modo === 'video') {
      return `url(${imgFundoVideo}) center/cover no-repeat`;
    }
    if (modo === 'luckys') {
      return `url(${imgFundoLuckys}) center/cover no-repeat`;
    }
    return `url(${imgFundoAudio}) center/cover no-repeat`;
  };

  return (
    <div style={{ 
      height: '100vh', 
      width: '100vw', 
      background: obterFundoDaSala(), 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      zIndex: 99999, 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      overflow: 'hidden' 
    }}>

    {/* 🌟 BARRA DE TOPO UNIFICADA PREMIUM (ESTIU TIKTOK/ALII - COM TAP TAPS) */}
        <div style={{
          position: 'absolute',
          top: '50px',
          left: '20px',
          right: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          zIndex: 1000,
          pointerEvents: 'auto'
        }}>
          
                {/* ========================================================================= */}
          {/* 🏟️ CABEÇALHO UNIFICADO NUMA LINHA ÚNICA (0 CORTES VERTICAIS)              */}
          {/* ========================================================================= */}
          {/* LADO ESQUERDO: Olhinho de Audiência + Contador de Bolas da Sala */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            
            {/* 👁️ CONTADOR DE AUDIÊNCIA COMPACTO EM VIDRO FUMADO */}
            <div 
              onClick={() => setMostrarLista(true)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                backgroundColor: 'rgba(0, 0, 0, 0.45)',
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
                border: '1px solid rgba(57, 255, 20, 0.5)',
                borderRadius: '20px',
                padding: '4px 10px',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3), 0 0 8px rgba(57, 255, 20, 0.2)'
              }}
            >
              <span style={{ fontSize: '12px' }}>👁️</span>
              <span style={{ color: '#FFF', fontSize: '11px', fontWeight: 'bold', fontFamily: 'monospace' }}>
                {audiencia}
              </span>
            </div>

            {/* ⚽ CONTADOR DE BOLAS DA LIVE LIMPO E ATUALIZADO */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              background: 'linear-gradient(135deg, rgba(0, 31, 63, 0.4) 0%, rgba(0, 0, 0, 0.6) 100%)',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              border: '1px solid #00D2FF',
              borderRadius: '20px',
              padding: '4px 10px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.4), 0 0 8px rgba(0,210,255,0.3)'
            }}>
              <span style={{ fontSize: '12px' }}>⚽</span>
              <span style={{ color: '#FFF', fontSize: '11px', fontWeight: '950', fontFamily: 'monospace' }}>
                {(() => {
                  const totalBolas = Math.round(caixaForteBolas);
                  if (totalBolas >= 10000000) return (totalBolas / 1000000).toFixed(1) + 'M';
                  return totalBolas.toLocaleString();
                })()}
              </span>
            </div>

          </div>

          {/* 👑 CENTRO DA LINHA: MEU SALDO EM TEMPO REAL ENCAIXADO NO FLUXO CENTRAL */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
            backdropFilter: 'blur(8px)',
            WebkitBackdropFilter: 'blur(8px)',
            border: '1px solid rgba(255, 215, 0, 0.6)',
            borderRadius: '16px', 
            padding: '4px 10px', 
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3), 0 0 8px rgba(255, 215, 0, 0.2)',
            boxSizing: 'border-box'
          }}>
            <span style={{ color: '#ccc', fontSize: '8px', fontWeight: 'bold', letterSpacing: '0.5px', textTransform: 'uppercase' }}>SALDO:</span>
            <span style={{ color: '#FFD700', fontSize: '10px', fontWeight: '900', textShadow: '0 0 5px rgba(255, 215, 0, 0.5)', fontFamily: 'monospace' }}>
              {meuSaldoBolas.toLocaleString()} ⚽
            </span>
          </div>

          {/* LADO DIREITO: Tap Taps + Botão de Sons Juntos e Alinhados */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            
            {/* 🔥 CONTADOR DE TAP TAPS INTEGRADO NO TOPO */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              backgroundColor: 'rgba(255, 0, 127, 0.1)',
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              border: '1px solid rgba(255, 0, 127, 0.5)',
              borderRadius: '20px',
              padding: '4px 10px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.3), 0 0 8px rgba(255, 0, 127, 0.2)'
            }}>
              <span style={{ fontSize: '12px' }}>🔥</span>
              <span style={{ color: '#FFF', fontSize: '11px', fontWeight: '950', fontFamily: 'monospace' }}>
                {totalTapTaps}
              </span>
            </div>

            {/* ✨ BOTÃO DE SONS NATIVO */}
            <button
              onClick={ativarSomGeral}
              style={{
                background: 'linear-gradient(90deg, #39FF14 0%, #22cc00 100%)',
                color: '#000',
                border: 'none',
                borderRadius: '20px',
                padding: '5px 12px',
                fontSize: '11px',
                fontWeight: '950',
                cursor: 'pointer',
                boxShadow: '0 0 12px #39FF14',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
                transition: 'transform 0.1s ease'
              }}
            >
              Sons
            </button>

          </div>

        </div>     

      {/* 🏟️ FEED VIP DE COMBOS E LUCKYS EM TEMPO REAL (CÓPIA FIEL DO ALII) */}
          {listaAvisosFeed.length > 0 && (
            <div style={{
              position: 'fixed',
              bottom: '220px',
              left: '15px',
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              zIndex: 10000,
              pointerEvents: 'none',
              maxWidth: '85vw'
            }}>
              {listaAvisosFeed.map((card) => {
                const ganhouGrande = card.multiplicadorGanho > 1;

                return (
                  <div 
                    key={card.id}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: 'transparent', // Totalmente limpo sem caixas gigantes
                      gap: '10px',
                      animation: 'fadeInLeft 0.2s ease-out'
                    }}
                  >
                    {/* Foto de Perfil de quem envia */}
                    <img 
                      src={card.fotoRemetente} 
                      alt="perfil" 
                      style={{ width: '36px', height: '36px', borderRadius: '50%', border: '1.5px solid #FFD700', objectFit: 'cover', boxShadow: '0 2px 8px rgba(0,0,0,0.5)' }} 
                    />

                    {/* Bloco Central de Textos com Sombra para Máxima Legibilidade */}
                    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2', textShadow: '1px 1px 3px rgba(0,0,0,0.8)' }}>
                      <span style={{ color: '#FFF', fontSize: '13px', fontWeight: 'bold' }}>{card.nomeRemetente}</span>
                      <span style={{ color: '#ccc', fontSize: '10px', fontWeight: '500' }}>Enviar ➡️ {card.nomeDestinatario}</span>
                      
                      {/* Linha de pontuação que muda de cor e pisca se ganhar prémio grande! */}
                      <span style={{ 
                        color: ganhouGrande ? '#39FF14' : '#FFD700', 
                        fontSize: '11px', 
                        fontWeight: '900',
                        animation: ganhouGrande ? 'pulse 0.5s infinite alternate' : 'none',
                        textShadow: ganhouGrande ? '0 0 5px #39FF14' : '1px 1px 2px rgba(0,0,0,0.9)'
                      }}>
                    
                  {(() => {
  // 1. Se for Lucky (pela flag isLucky ou se o tipo for lucky)
  if (card.isLucky || card.tipo === 'lucky') {
    return ` Bateu ${card.multiplicadorGanho}X! Ganho Total: ${card.totalGanhoBolas} ⚡ `;
  }
  // 2. Se for Presente de Vídeo legítimo (pelo tipo, flag ehVideo ou se contiver o caminho de vídeo)
  if (
    card.tipo === 'video' || 
    card.ehVideo === true || 
    (card.presenteIcone && card.presenteIcone.toLowerCase().includes('video')) ||
    (card.videoUrl && card.videoUrl !== "")
  ) {
    return ` Enviou ${card.presenteNome} 🎁 `;
  }
  // 3. Se não for nenhum dos dois, é um Sticker legítimo -> Trevo!
  return ` Enviou ${card.presenteNome} 🍀 `;
})()}

                  </span>
                </div>

                            {/* Ícone do Presente Pequeno */}
            {card.presenteIcone && (
              <img 
                src={card.presenteIcone} 
                alt="item" 
                style={{ width: '26px', height: '26px', objectFit: 'contain', marginLeft: '5px', filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))' }} 
              />
            )}

                    {/* 🎯 Alinhamento Supremo: Se o remetente for eu, lê o estado atómico síncrono da contagem para mexer na mesma frame da bolinha */}
                    <span style={{
                      color: '#FFF',
                      fontSize: '22px',
                      fontWeight: '950',
                      fontFamily: 'system-ui, sans-serif',
                      fontStyle: 'italic',
                      marginLeft: '6px',
                      textShadow: '2px 2px 4px #000, 0 0 8px rgba(255,255,255,0.2)'
                    }}>
                      x{card.uidRemetente === meuId ? contagemComboCliques : card.quantidadeCombo}
                    </span>
                  </div>
                );
              })}
            </div>
          )}                

                {/* 🎬 FILA DE ANIMAÇÕES: cada presente com o seu próprio elemento */}
      {animacoesAtivas.map((anim) => {
  // 💍 Presente com versão sem fundo (assets/presentes/transparentes):
  // recorte feito por IA, sem filtro de verde, cores do presente intactas.
  const semFundo = videoSemFundo(anim.media);
  if (semFundo) {
    return (
      <div
        key={anim.chave}
        style={{
          position: 'fixed', inset: 0, zIndex: 99999,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          pointerEvents: 'none'
        }}
      >
        <PresenteTransparente
          src={semFundo}
          tamanho={280}
          comSom={false}
          aoTerminar={() => removerAnimacao(anim.chave)}
        />
      </div>
    );
  }

  // 💡 SEPARAÇÃO PRECISÃO TOTAL: Confia 100% no motor que detetou o tipo no Firebase
  if (anim.ehVideo) {
    return (
      <AnimacaoVideoPresente
        key={anim.chave}
        chave={anim.chave}
        src={anim.media}
        poster={anim.poster}
        aoTerminar={removerAnimacao}
      />
    );
  }

  // 💡 Se não for marcado como vídeo pelo motor, é OBRIGATORIAMENTE o teu Sticker na caixinha!
  return (
    <AnimacaoStickerPresente
      key={anim.chave}
      chave={anim.chave}
      src={anim.media}
      aoTerminar={removerAnimacao}
    />
  );
})}

      {modo === 'luckys' ? (
        /* ⚡ GRELHA QUADRADA ESTILO TIKTOK INTEGRADA - SUBIDA E SEM CORTES */
                <div style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100vw',
          // 📐 ECONOMIA DE ESPAÇO: Reduzido de 68vh para apenas 46vh para libertar a metade inferior do ecrã!
          height: '46vh', 
          position: 'absolute',
          top: '115px', // Sobe ligeiramente para aproveitar o topo livre que conquistámos
          padding: '0 12px',
          overflow: 'hidden'
        }}>

        {/* GRELHA DOS 9 LUGARES (1 DONO NO LUGAR 1 + 8 PARTICIPANTES EXTRATÍVEIS) */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(3, 1fr)', // 🚀 PASSOU A 3 COLUNAS HORIZONTAIS
            gap: '6px', 
            width: '100%',
            height: '100%'
          }}>
            {/* 🦾 MATRIZ 3x3: Geramos 9 quadrados no total */}
            {Array(9).fill(null).map((_, index) => {
              // Se for o primeiro quadrado (Lugar 1), força a exibição do Dono da Sala
              const esElPrimeiroLugar = index === 0;

              // 🚀 ACERTO LOGICO: Como o Dono ocupa o index 0, os outros bancos (1 a 8) leem o array de 0 a 7
              const usuarioNoQuadrado = esElPrimeiroLugar
                ? { uid: dadosDaSala?.donoId, nome: dadosDaSala?.donoNome || "ANFITRIÃO", foto: dadosDaSala?.donoFoto }
                : participantes[index - 1]; 

              const souEuNesseQuadrado = usuarioNoQuadrado?.uid === meuId && meuId !== undefined;

              return (
                <div
                  key={index}
                  id={usuarioNoQuadrado?.uid || `banco_vazio_${index}`}
                  onClick={() => !esElPrimeiroLugar && ocuparLugar(index - 1)}
                  style={{
                    width: '100%',
                    // 📐 COMPACTAÇÃO: Reduzido de 105px para 82px para as 3 linhas caberem perfeitamente
                    height: '82px', 
                    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.01) 100%)',
                    backdropFilter: 'blur(8px)',
                    WebkitBackdropFilter: 'blur(8px)',
                    borderRadius: '12px',
                    // 🌟 Altera a linha da borda dentro do return do map da Grelha Luckys para esta:
                    border: usuarioNoQuadrado?.uid === uidVencedorNeonAtivo
                      ? '3px solid #39FF14'
                      : esElPrimeiroLugar
                        ? '2px solid #FFD700'
                        : souEuNesseQuadrado 
                          ? '2px solid #39FF14' 
                          : '1px solid rgba(255, 255, 255, 0.35)',
                    position: 'relative',
                    overflow: 'hidden',
                    cursor: esElPrimeiroLugar ? 'default' : 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    boxSizing: 'border-box'
                  }}
                >
                  {/* STREAMING DE VÍDEO REAL OU FOTO DE PERFIL */}
                  {souEuNesseQuadrado && cameraLigada && trackVideo ? (
                    <div ref={node => node && trackVideo.play(node)} style={{ width: '100%', height: '100%' }} />
                  ) : (esElPrimeiroLugar && !souDono && dadosDaSala?.ativa) ? (
                    // Se for o visualizador a ver o vídeo do dono remoto
                    <div id={dadosDaSala?.donoId} style={{ width: '100%', height: '100%' }} />
                  ) : usuarioNoQuadrado?.foto ? (
                    <img src={usuarioNoQuadrado.foto} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="avatar" />
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                      <span style={{ color: 'rgba(255, 255, 255, 0.25)', fontSize: '9px', fontWeight: 'bold', fontFamily: 'monospace', letterSpacing: '0.5px' }}>LIVRE</span>
                    </div>
                  )}

                                  {/* 🟢 Alinhamento Fiel ao Print Antigo nas Salas Quadradas de Luckys */}
                  {usuarioNoQuadrado?.uid && uidVencedorNeonAtivo === usuarioNoQuadrado.uid && (
                    <div style={{ position: 'absolute', inset: 0, borderRadius: '12px', border: '3px solid #39FF14', boxShadow: '0 0 25px #39FF14, inset 0 0 15px #39FF14', backgroundColor: 'rgba(57, 255, 20, 0.45)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 99, pointerEvents: 'none', animation: 'pulse 0.3s infinite alternate' }}>
                      <span style={{ color: '#FFF', fontSize: '18px', fontWeight: '950', textShadow: '0 0 6px #000, 0 0 10px #39FF14', fontStyle: 'italic' }}>
                        +{listaAvisosFeed.find(card => card.uidRemetente === usuarioNoQuadrado.uid || card.id !== '')?.multiplicadorGanho || 10}X!
                      </span>
                      <span style={{ color: '#FFF', fontSize: '7px', fontWeight: 'bold', letterSpacing: '0.5px', textTransform: 'uppercase', opacity: 0.9 }}>CRAQUE</span>
                    </div>
                  )}

                  {/* IDENTIFICADOR DE NOME NO RODAPÉ DO QUADRADINHO */}
                  <div style={{ 
                    position: 'absolute', 
                    bottom: '6px', 
                    left: '6px', 
                    right: '6px', 
                    backgroundColor: 'rgba(0,0,0,0.5)', 
                    padding: '3px 6px', 
                    borderRadius: '6px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    backdropFilter: 'blur(4px)',
                    border: '1px solid rgba(255,255,255,0.05)'
                  }}>
                    <span style={{ color: esElPrimeiroLugar ? '#FFD700' : (usuarioNoQuadrado ? '#FFF' : '#777'), fontSize: '9px', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '80%' }}>
                      {esElPrimeiroLugar ? `👑 ${usuarioNoQuadrado.nome}` : (usuarioNoQuadrado ? usuarioNoQuadrado.nome : `LUGAR ${index + 1}`)}
                    </span>
                    
                          {/* Botão de Sair do banco para participantes normais */}
                    {!esElPrimeiroLugar && souEuNesseQuadrado && (
                      <span 
                        onClick={async (e) => { 
                          e.stopPropagation(); 
                          await desocuparLugarMestre(index - 1); 
                        }} 
                        style={{ 
                          position: 'absolute', 
                          top: '2px', 
                          right: '2px', 
                          backgroundColor: '#FF3B30', 
                          color: '#FFFFFF', 
                          fontSize: '11px', 
                          fontWeight: '900', 
                          width: '20px', 
                          height: '20px', 
                          borderRadius: '50%', 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          cursor: 'pointer', 
                          zIndex: 99999, 
                          boxShadow: '0 2px 6px rgba(255,59,48,0.4)', 
                          border: '1px solid rgba(255,255,255,0.2)' 
                        }}
                      >
                        ✕
                      </span>
                    )}
                  </div>

                </div>
              );
            })}
          </div>
        </div>
      ) : (

      /* 🏟️ TEU ESTÁDIO CLÁSSICO REDONDO TOTALMENTE INTACTO */
        <>
          <div style={{ position: 'absolute', zIndex: 2, textAlign: 'center', transform: modo === 'voz' ? 'translate(0px, -180px)' : 'translate(-92px, -90px)' }}>
            <div id={dadosDaSala?.donoId} style={{ width: modo === 'voz' ? tamanhoBolaDono : '135px', height: modo === 'voz' ? tamanhoBolaDono : '220px', borderRadius: modo === 'voz' ? '50%' : '14px', border: dadosDaSala?.donoId === uidVencedorNeonAtivo ? '4px solid #39FF14' : '4px solid rgba(57, 255, 20, 0.4)', boxShadow: dadosDaSala?.donoId === uidVencedorNeonAtivo ? '0 0 30px #39FF14, inset 0 0 20px #39FF14' : '0 0 10px rgba(57, 255, 20, 0.2)', overflow: 'hidden', position: 'relative', backgroundColor: 'rgba(0, 0, 0, 0.4)' }}>               
              {souDono && cameraLigada && trackVideo ? (
                <div ref={node => node && trackVideo.play(node)} style={{ width: '100%', height: '100%', borderRadius: '50%' }} />
              ) : (
                <img src={dadosDaSala?.donoFoto || ""} style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', top: 0, left: 0 }} alt="dono" />
              )}

              {/* 🟢 OVERLAY DE PRÉMIO FIEL: Acende em cima da imagem se o Dono ganhar o prémio alto */}
              {dadosDaSala?.donoId && uidVencedorNeonAtivo === dadosDaSala.donoId && (
                <div style={{ position: 'absolute', inset: 0, borderRadius: modo === 'voz' ? '50%' : '14px', border: '3px solid #39FF14', boxShadow: '0 0 25px #39FF14, inset 0 0 15px #39FF14', backgroundColor: 'rgba(57, 255, 20, 0.45)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 99, pointerEvents: 'none', animation: 'pulse 0.3s infinite alternate' }}>
                  <span style={{ color: '#FFF', fontSize: '20px', fontWeight: '950', textShadow: '0 0 8px #000, 0 0 12px #39FF14', fontStyle: 'italic' }}>
                    +{listaAvisosFeed.find(card => card.uidRemetente === meuId || card.nomeDestinatario === dadosDaSala?.donoNome)?.multiplicadorGanho || 10}X!
                  </span>
                  <span style={{ color: '#FFF', fontSize: '8px', fontWeight: 'bold', letterSpacing: '0.5px', textTransform: 'uppercase', opacity: 0.9 }}>CRAQUE</span>
                </div>
              )}
            </div>
            <p style={{ color: '#39FF14', marginTop: '10px', fontWeight: 'bold', textShadow: '0 2px 4px rgba(0,0,0,0.6)' }}>{dadosDaSala?.donoNome || "CARREGANDO..."}</p>
          </div>

          {participantes.map((p, index) => {
            // 📐 MATEMÁTICA DUPLA: PIRÂMIDE PARA ÁUDIO VS COLUNAS TIKTOK PARA VÍDEO (INTACTA)
            const colVoz = index % 4; 
            const linVoz = Math.floor(index / 4); 

            const colVideo = index % 2; 
            const linVideo = Math.floor(index / 2); 

            // 🌟 JOGADA MESTRE: Reduzido de +55 para +42 no modo vídeo. 
            // Puxa a grelha toda 13px para a esquerda, livrando as janelas dos participantes do corte da borda!
            const x = modo === 'voz' ? (colVoz - 1.5) * 82 : colVideo * 92 + 42; 
            const y = modo === 'voz' ? linVoz * 95 - 50 : linVideo * 56 - 200; 

            return (
              <div key={index} style={{ position: 'absolute', transform: `translate(${x}px, ${y}px)`, textAlign: 'center' }}>
                
                {/* BANCOS MODERNIZADOS COM GLASSMORPHISM - COORDENADAS E TAMANHOS INTACTOS */}
                <div 
                  id={p?.uid} 
                  onClick={() => ocuparLugar(index)} 
                  style={{ 
                    width: modo === 'voz' ? tamanhoBolaParticipante : '85px', 
                    height: modo === 'voz' ? tamanhoBolaParticipante : '51px', 
                    borderRadius: modo === 'voz' ? '50%' : '8px', 
                    border: p ? '2px solid #FFF' : '1.5px solid rgba(255, 255, 255, 0.45)',
                    background: p ? 'none' : 'rgba(255, 255, 255, 0.08)',
                    backdropFilter: 'blur(4px)',
                    WebkitBackdropFilter: 'blur(4px)',
                    overflow: 'hidden', 
                    position: 'relative', 
                    cursor: 'pointer',
                    boxShadow: p ? '0 4px 10px rgba(0,0,0,0.3)' : 'inset 0 1px 4px rgba(0,0,0,0.4)'
                  }}
                >
                  {p?.uid === meuId && cameraLigada && trackVideo ? (
                    <div ref={node => node && trackVideo.play(node)} style={{ width: '100%', height: '100%', borderRadius: modo === 'voz' ? '50%' : '0' }} />
                  ) : p ? (
                    <img src={p.foto} style={{ width: '100%', height: '100%', objectFit: 'cover', position: 'absolute', top: 0, left: 0 }} alt="p" />
                  ) : (
                    <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: 0.3 }}>
                      {modo === 'voz' ? <span style={{ fontSize: '12px' }}>🎤</span> : <span style={{ fontSize: '12px' }}>🎥</span>}
                    </div>
                  )}

                  {/* TEXTO TRANCADO COM MAIS RESPIRO NO RETÂNGULO MAIOR */}
                  {modo !== 'voz' && (
                    <div style={{ position: 'absolute', bottom: '3px', left: '4px', right: '4px', backgroundColor: 'rgba(0,0,0,0.5)', padding: '2px 4px', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(2px)', pointerEvents: 'none', zIndex: 10, border: '1px solid rgba(255,255,255,0.05)' }}>
                      <span style={{ color: p ? '#39FF14' : '#FFF', fontSize: '8.5px', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {p ? p.nome : "LIVRE"}
                      </span>
                    </div>
                  )}

                                  {/* 🟢 Alinhamento Fiel ao Print Antigo: Overlay verde vibrante + Texto + Multiplicador */}
                  {p?.uid && uidVencedorNeonAtivo === p.uid && (
                    <div style={{ position: 'absolute', inset: 0, borderRadius: modo === 'voz' ? '50%' : '8px', border: '3px solid #39FF14', boxShadow: '0 0 25px #39FF14, inset 0 0 15px #39FF14', backgroundColor: 'rgba(57, 255, 20, 0.45)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 99, pointerEvents: 'none', animation: 'pulse 0.3s infinite alternate' }}>
                      <span style={{ color: '#FFF', fontSize: '18px', fontWeight: '950', textShadow: '0 0 6px #000, 0 0 10px #39FF14', fontStyle: 'italic' }}>
                        +{listaAvisosFeed.find(card => card.uidRemetente === p.uid || card.id !== '')?.multiplicadorGanho || 5}X!
                      </span>
                      <span style={{ color: '#FFF', fontSize: '7px', fontWeight: 'bold', letterSpacing: '0.5px', textTransform: 'uppercase', opacity: 0.9 }}>CRAQUE</span>
                    </div>
                  )}

                </div>
                {modo === 'voz' && (
                  <p style={{ color: '#FFF', fontSize: '9px', marginTop: '5px', fontWeight: 'bold', textShadow: '1px 1px 2px #000' }}>{p ? p.nome : 'LIVRE'}</p>
                )}
                {p?.uid === meuId && (
                <button onClick={(e) => { e.stopPropagation(); ocuparLugar(index); }} style={{ position: 'absolute', top: '2px', right: '2px', backgroundColor: '#FF3B30', color: '#FFFFFF', border: 'none', fontSize: '11px', fontWeight: '900', width: '20px', height: '20px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', zIndex: 99999, boxShadow: '0 2px 6px rgba(255,59,48,0.4)', border: '1px solid rgba(255,255,255,0.2)' }}>✕</button>
                )}
              </div>
            );
          })}
        </>
      )}

    {/* ================= RODAPÉ DE BOTÕES RECONSTRUÍDO (FIXO E INTEGRADO) ================= */}
      <div style={{ 
        position: 'fixed', 
        bottom: '25px', 
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex', 
        gap: '15px', 
        backgroundColor: 'rgba(255, 255, 255, 0.08)', // Vidro translúcido refinado
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.4)',
        padding: '12px 22px', 
        borderRadius: '50px', 
        alignItems: 'center', 
        zIndex: 999999, 
        width: 'auto',
        whiteSpace: 'nowrap'
      }}>
        <div onClick={alternarMicrofone} style={{ cursor: 'pointer', fontSize: '20px', transition: 'transform 0.1s ease' }}>🎤</div>
        {(modo === 'video' || modo === 'luckys') && (
          <div onClick={alternarCamera} style={{ cursor: 'pointer', fontSize: '20px', transition: 'transform 0.1s ease' }}>🎥</div>
        )}
        
                {/* 🎨 BOTÃO 1 MODERNO: REGRAS ASSEMMÉTRICAS DO TREVO 🍀 (DONO VS ESPETADOR) */}
        <div 
          onClick={() => { 
            if (souDono) {
              // 1. Regra do Anfitrião: Abre a sua própria Caderneta pessoal em luz verde!
              setMostrarCadernetaDono(true);
              setMostrarMenuStickers(true); // Abre a gaveta para ele ver o Álbum
              setUtilizadorAlvoId(meuId);   // Tranca o ID dele para a antena ler o seu Álbum
            } else {
              // 2. Regra do Espetador: Abre a seleção de destinatários para doar cromos
              setTipoMenuAtivo("stickers");
              
              // Pré-carregamento de segurança: Se o Dono for o único na sala, define-o logo como alvo inicial para o modal não abrir vazio
              const donoIdEfetivo = dadosDaSala?.donoId || idDaSalaDestino;
              if (donoIdEfetivo) {
                setUtilizadorAlvoId(donoIdEfetivo);
                setDestinatarioEscolhido({
                  uid: donoIdEfetivo,
                  nome: dadosDaSala?.donoNome || "ANFITRIÃO",
                  foto: dadosDaSala?.donoFoto || ""
                });
              }
              
              setMostrarSelecaoDestinatario(true); 
              setMostrarMenuStickers(false); 
              setMostrarMenuPresentesNormais(false); 
              setMostrarMenuLuckys(false); 
              setMostrarCadernetaDono(false);
            }
          }} 
          style={{ 
            cursor: 'pointer', 
            fontSize: '20px', 
            backgroundColor: souDono ? 'rgba(57, 255, 20, 0.2)' : 'rgba(0, 247, 255, 0.2)', 
            padding: '5px', 
            borderRadius: '50%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            border: souDono ? '1px solid #39FF14' : '1px solid #00f7ff',
            boxShadow: souDono ? '0 0 10px rgba(57, 255, 20, 0.3)' : '0 0 10px rgba(0, 247, 255, 0.3)'
          }}
        >
          🍀
        </div>

        {/* ⚡ BOTÃO 2: MODO LUCKYS RAIO (ABRE O MENU DIRETO SEM CLIQUE REDUNDANTE) */}
        <div 
                    onClick={() => { 
            setTipoMenuAtivo("luckys");
            setMostrarSelecaoDestinatario(true); 
            setMostrarMenuLuckys(false); 
            setMostrarMenuStickers(false); 
            setMostrarMenuPresentesNormais(false); 
          }}
          style={{ 
            cursor: 'pointer', 
            fontSize: '20px', 
            backgroundColor: 'rgba(255, 215, 0, 0.2)', 
            padding: '5px', 
            borderRadius: '50%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            border: '1px solid #FFD700', 
            boxShadow: '0 0 10px rgba(255, 215, 0, 0.4)' 
          }}
        >
          ⚡
        </div>

        {/* 🎁 BOTÃO 3: PRESENTES VÍDEOS MP4 (SELEÇÃO DE DESTINATÁRIO PRIMEIRO) */}
        <div 
          onClick={() => { 
            setTipoMenuAtivo("mp4");
            setMostrarSelecaoDestinatario(true); 
            setMostrarMenuPresentesNormais(false); 
            setMostrarMenuStickers(false); 
            setMostrarMenuLuckys(false); 
          }} 
          style={{ 
            cursor: 'pointer', 
            fontSize: '20px', 
            backgroundColor: 'rgba(255, 140, 0, 0.2)', 
            padding: '5px', 
            borderRadius: '50%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            border: '1px solid #FF8C00',
            boxShadow: '0 0 10px rgba(255, 140, 0, 0.4)'
          }}
        >
          🎁
        </div>

        {!souDono && (
          <button
            onClick={async (e) => {
              e.stopPropagation();
              setTotalTapTaps(prev => prev + 1);
              if (!window.acumuladorTapsBancada) window.acumuladorTapsBancada = 0;
              window.acumuladorTapsBancada += 1;
              if (window.acumuladorTapsBancada >= 10) {
                window.acumuladorTapsBancada = 0;
                try {
                  const { doc: fDoc, updateDoc: fUpdateDoc, increment: fIncrement } = await import('firebase/firestore');
                  await fUpdateDoc(fDoc(db, "salas_bancada", idDaSalaDestino), { totalTapTaps: fIncrement(10) });
                } catch (errTaps) { console.error("Erro ao enviar Tap Taps:", errTaps); }
              }
            }}
            style={{ background: 'rgba(255, 0, 127, 0.2)', border: '1px solid #FF007F', borderRadius: '50%', width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', cursor: 'pointer', boxShadow: '0 0 8px rgba(255, 0, 127, 0.2)' }}
          >
            🔥
          </button>
        )}
        <Share2 color="white" size={22} onClick={partilharBancada} style={{ cursor: 'pointer' }} />
        <LogOut 
          color="#FF4444" 
          size={22} 
          onClick={async () => { 
            if (souDono && meuId) {
              try {
                await deleteDoc(doc(db, "salas_bancada", idDaSalaDestino)); 
              } catch (errDelete) {
                console.error("Erro ao fechar estádio:", errDelete);
              }
            } 
            aoSair(); 
          }} 
          style={{ cursor: 'pointer' }} 
        />

      </div>

    {/* ✨ NOVO MODAL: STICKERS DE IMAGEM (CONTROLADO PELO BOTÃO AZUL NÉON) - CORREÇÃO DE LARGURA HORIZONTAL */}
      {mostrarMenuStickers && (
        <div style={{ 
          position: 'fixed', 
          inset: 0, 
          backgroundColor: 'rgba(0,0,0,0.75)', 
          zIndex: 15000, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
        }}>
          <div style={{ 
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.01) 100%)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            padding: '16px', 
            borderRadius: '25px', 
            border: '1px solid #00f7ff', 
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.5), 0 0 20px rgba(0, 247, 255, 0.2)', 
            width: '92%', 
            maxWidth: '410px', 
            boxSizing: 'border-box'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h3 style={{ color: '#00f7ff', margin: 0, fontWeight: '900', fontSize: '14px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>STICKERS ANIMADOS ✨</h3>
              <button onClick={() => setMostrarMenuStickers(false)} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold', cursor: 'pointer', fontSize: '12px' }}>✕</button>
            </div>
            
            <div className="presentes-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px', padding: '0 8px', height: '320px', maxHeight: '320px', overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch', boxSizing: 'border-box' }}>
              {LISTA_REAL.map((pres) => {
                const cromoNumReal = Number(pres.id) - 100;
                const cromoAdquiridoPeloDono = typeof cromosDesbloqueadosIds !== 'undefined' 
                  ? cromosDesbloqueadosIds.includes(cromoNumReal) 
                  : false;

                return (
                  <div 
                    key={pres.id} 
                    onClick={() => {
                      // 🚀 NOVA REGRA 4.3: Se for o Dono da Sala, o clique é desativado. Ele só pode ver o Álbum!
                      if (souDono) return;

                      if (cromoAdquiridoPeloDono) {
                        alert(`Este cromo já foi ADQUIRIDO pelo Anfitrião! Escolhe outro da caderneta. 🎫`);
                        return;
                      }
                      
                      const alvoFinal = utilizadorAlvoId === idDaSalaDestino 
                        ? { uid: idDaSalaDestino, nome: dadosDaSala?.donoNome }
                        : participantes.find(p => p && p.uid === utilizadorAlvoId) || { uid: idDaSalaDestino, nome: dadosDaSala?.donoNome };
                      
                      // Executa o envio preservando os links corretos de media para o canvas/imagem não quebrarem
                      processarEnvioPresente({ 
                        ...pres, 
                        cromoNumero: cromoNumReal, 
                        tipoPresente: 'sticker', 
                        tipo: 'sticker', // Sincroniza a flag dupla avaliada nas funções
                        iconeUrl: pres.icone || pres.url || "", // 🔥 CORRIGIDO: Passa o link real da imagem em vez do emoji 
                        videoUrl: "" 
                      }, alvoFinal);
                      
                      setMostrarMenuStickers(false);
                      setMostrarSelecaoDestinatario(false);
                    }}
                    style={{ 
                      textAlign: 'center', 
                      cursor: cromoAdquiridoPeloDono ? 'not-allowed' : 'pointer', 
                      padding: '6px 4px', 
                      background: 'rgba(255, 255, 255, 0.03)', 
                      border: cromoAdquiridoPeloDono ? '1px dashed rgba(255,255,255,0.15)' : '1px solid rgba(255,255,255,0.06)',
                      borderRadius: '15px', 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center',
                      transition: 'all 0.2s ease',
                      boxSizing: 'border-box'
                    }}
                  >
                    <div style={{ width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '4px' }}>
                      <img 
                        src={pres.icone} 
                        style={{ 
                          maxWidth: '100%', 
                          maxHeight: '100%', 
                          objectFit: 'contain',
                          filter: cromoAdquiridoPeloDono ? 'grayscale(100%) opacity(30%)' : 'none'
                        }} 
                        alt={pres.nome}
                        loading="lazy"
                      />
                    </div>
                    <p style={{ color: cromoAdquiridoPeloDono ? '#666' : '#00f7ff', fontSize: '9px', fontWeight: 'bold', margin: '0 0 2px 0', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', lineHeight: '1.1', textTransform: 'uppercase', width: '100%' }}>
                      {cromoAdquiridoPeloDono ? 'ADQUIRIDO' : pres.nome}
                    </p>
                    <p style={{ color: cromoAdquiridoPeloDono ? '#666' : 'white', fontSize: '9px', margin: 0, fontWeight: '700', fontFamily: 'monospace' }}>
                      {cromoAdquiridoPeloDono ? '✓' : `${pres.preco} ⚽`}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

    {/* 🎁 NOVO MODAL: PRESENTES PREMIUM EM VÍDEO MP4 (CONTROLADO PELO BOTÃO LARANJA) - CORREÇÃO DE SCROLL HORIZONTAL */}
      {mostrarMenuPresentesNormais && (
        <div style={{ 
          position: 'fixed', 
          inset: 0, 
          backgroundColor: 'rgba(0,0,0,0.75)', 
          zIndex: 15000, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
        }}>
          <div style={{ 
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.01) 100%)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            padding: '16px', 
            borderRadius: '25px', 
            border: '1px solid #FF8C00', 
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.5), 0 0 20px rgba(255, 140, 0, 0.2)', 
            width: '92%', 
            maxWidth: '410px', // ALARGADO: Dá oxigénio suficiente para a 3ª coluna não cortar na horizontal
            boxSizing: 'border-box'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <h3 style={{ color: '#FF8C00', margin: 0, fontWeight: '900', fontSize: '14px', letterSpacing: '0.5px', textTransform: 'uppercase' }}>PRESENTES PREMIUM 🎁</h3>
              <button onClick={() => setMostrarMenuPresentesNormais(false)} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 'bold', cursor: 'pointer', fontSize: '12px' }}>✕</button>
            </div>
            
            <div className="presentes-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px', padding: '0 8px', height: '320px', maxHeight: '320px', overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch', boxSizing: 'border-box' }}>
              {LISTA_PRESENTES.map((pres) => (
                <div 
                  key={pres.id} 
                  onClick={() => {
                    setPresenteSelecionado(pres);
                    aquecerVideoPresente(pres.video);
                    
                    const alvoFinal = utilizadorAlvoId === idDaSalaDestino 
                      ? { uid: idDaSalaDestino, nome: dadosDaSala?.donoNome }
                      : participantes.find(p => p && p.uid === utilizadorAlvoId) || { uid: idDaSalaDestino, nome: dadosDaSala?.donoNome };

                    processarEnvioPresente(pres, alvoFinal);

                    setMostrarMenuPresentesNormais(false);
                    setMostrarSelecaoDestinatario(false);
                  }}
                  style={{ 
                    textAlign: 'center', 
                    cursor: 'pointer', 
                    padding: '6px 4px', 
                    background: 'rgba(255, 255, 255, 0.03)', 
                    border: '1px solid rgba(255, 255, 255, 0.06)',
                    borderRadius: '15px', 
                    display: 'flex', 
                    flexDirection: 'column', 
                    alignItems: 'center',
                    transition: 'all 0.2s ease',
                    boxSizing: 'border-box'
                  }}
                >
                  {/* COMPACTADO: Imagem ligeiramente ajustada para garantir encaixe horizontal perfeito */}
                  <div style={{ width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '4px' }}>
                    <img 
                      src={pres.icone} 
                      style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} 
                      alt={pres.nome}
                      loading="lazy"
                    />
                  </div>
                  <p style={{ color: '#FF8C00', fontSize: '9px', fontWeight: 'bold', margin: '0 0 2px 0', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', lineHeight: '1.1', textTransform: 'uppercase', width: '100%' }}>{pres.nome}</p>
                  <p style={{ color: 'white', fontSize: '9px', margin: 0, fontWeight: '700', fontFamily: 'monospace' }}>{pres.preco} ⚽</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

    {/* ⚡ MODAL PREMIUM: LUCKYS MANTIDO TOTALMENTE INTACTO COM AS TUAS TRANCAS - CORREÇÃO DE LARGURA */}
      {mostrarMenuLuckys && (
        <div style={{ 
          position: 'fixed', 
          inset: 0, 
          backgroundColor: 'rgba(0,0,0,0.75)', 
          zIndex: 15000, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center' 
        }}>
          <div style={{ 
            position: 'relative',
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.01) 100%)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            padding: '16px', 
            borderRadius: '25px', 
            border: '2px solid #FFD700', 
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.6), 0 0 25px rgba(255, 215, 0, 0.25)', 
            width: '92%', 
            maxWidth: '410px', 
            boxSizing: 'border-box'
          }}>
            
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <h3 style={{ color: '#FFD700', margin: 0, fontWeight: '900', fontSize: '14px', letterSpacing: '1px', textTransform: 'uppercase', textShadow: '0 0 10px rgba(255, 215, 0, 0.4)' }}>LUCKYS ⚡</h3>
                {/* Botão de interrogação regulamentar para aprovação imediata nas lojas */}
                <button 
                  onClick={() => {
                    const elemRegras = document.getElementById("subModalRegrasLuckysSala");
                    if (elemRegras) elemRegras.style.display = "block";
                  }} 
                  style={{ background: 'none', border: 'none', fontSize: '15px', cursor: 'pointer', padding: '0 4px', display: 'flex', alignItems: 'center' }}
                  title="Ver Regras de Probabilidade"
                >
                  ❓
                </button>
              </div>
              <button onClick={() => setMostrarMenuLuckys(false)} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FFD700', fontWeight: 'bold', fontSize: '12px', cursor: 'pointer' }}>✕</button>
            </div>

            {/* GAVETA INTERNA DE REGRAS MANDATÓRIAS EM PORTUGUÊS CONTRA REJEIÇÕES */}
            <div id="subModalRegrasLuckysSala" style={{ display: 'none', position: 'absolute', inset: 0, backgroundColor: 'rgba(10,15,20,0.98)', zIndex: 16000, padding: '16px', borderRadius: '25px', color: '#fff', textAlign: 'left', overflowY: 'auto', boxSizing: 'border-box', border: '2px solid #FFD700' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px', borderBottom: '1px solid rgba(255,255,255,0.1)', paddingBottom: '6px' }}>
                <h4 style={{ margin: 0, color: '#FFD700', fontSize: '12px', fontWeight: '900' }}>🎡 REGRAS DO PRESENTE DA SORTE</h4>
                <button onClick={() => { const el = document.getElementById("subModalRegrasLuckysSala"); if (el) el.style.display = "none"; }} style={{ background: '#FFD700', border: 'none', borderRadius: '6px', padding: '2px 8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '10px', color: '#000' }}>FECHAR</button>
              </div>
              <div style={{ fontSize: '11px', lineHeight: '1.4', display: 'flex', flexDirection: 'column', gap: '8px', color: '#e0e0e0' }}>
                <p><strong>1. Funcionamento:</strong> O utilizador adquire e envia Presentes da Sorte através do seu saldo de Bolas, obtendo uma probabilidade aleatória de reaver recompensas com valores multiplicados.</p>
                <p><strong>2. Saldo Líquido Imediato:</strong> Todas as recompensas ganhas entram instantaneamente como saldo real na sua carteira, ficando 100% livres e disponíveis para levantamento imediato via transferência bancária, sem bloqueios ou trocas burocráticas.</p>
                <p><strong>3. Probabilidades Regulares:</strong><br />
                  Perder (0x): 60.89% | Retorno (1x): 22.00% | Dobro (2x): 11.50% | 5x: 3.00% | 10x: 2.00% | 20x: 0.50% | 50x: 0.10% | 100x: 0.01%.<br />
                  <span style={{ color: '#888' }}>(RTP Geral Estável: 96%).</span>
                </p>
                <p><strong>4. Canal de Caça-Jackpot 1000X (Apito e Capitão):</strong><br />
                  Perder (0x): 99.904% | Prémio Supremo (1000x): 0.096%.<br />
                  <span style={{ color: '#888' }}>(RTP Geral Estável: 96%).</span>
                </p>
              </div>
            </div>

            <div className="presentes-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '6px', padding: '0 8px', height: '320px', maxHeight: '320px', overflowY: 'auto', overflowX: 'hidden', WebkitOverflowScrolling: 'touch', boxSizing: 'border-box' }}>
              {LISTA_LUCKYS.map((pres) => {
                const estaSelecionado = presenteSelecionado?.id === pres.id;
                return (
                  <div 
                    key={pres.id} 
                    onClick={() => {
                      setPresenteSelecionado(pres); 
                      setUltimoLuckyEnviado(pres); 
                    }}
                    style={{ 
                      textAlign: 'center', 
                      cursor: 'pointer', 
                      padding: '6px 4px', 
                      background: estaSelecionado ? 'rgba(255, 215, 0, 0.1)' : 'rgba(255, 255, 255, 0.03)', 
                      border: estaSelecionado ? '2px solid #FFD700' : '1px solid rgba(255, 255, 255, 0.06)', 
                      boxShadow: estaSelecionado ? '0 0 10px rgba(255, 215, 0, 0.3)' : 'none',
                      borderRadius: '12px', 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      transition: 'all 0.2s ease',
                      boxSizing: 'border-box'
                    }}
                  >
                    <div style={{ width: '34px', height: '34px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '4px' }}>
                      <img src={pres.icone} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} alt={pres.nome} loading="lazy" />
                    </div>
                    <p style={{ color: '#FFF', fontSize: '8px', fontWeight: 'bold', margin: '0 0 2px 0', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', lineHeight: '1.1', textTransform: 'uppercase', width: '100%' }}>{pres.nome}</p>
                    <p style={{ color: '#FFD700', fontSize: '9px', fontWeight: '900', margin: 0, fontFamily: 'monospace' }}>⚽ {pres.preco}</p>
                  </div>
                );
              })}
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px', paddingTop: '12px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <select value={quantidadeSelecionada} onChange={(e) => setQuantidadeSelecionada(Number(e.target.value))} style={{ backgroundColor: 'rgba(0,0,0,0.5)', color: '#FFD700', border: '1px solid #FFD700', padding: '6px 24px 6px 12px', borderRadius: '12px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', appearance: 'none', outline: 'none' }}>
                  <option value={1}>1</option>
                  <option value={10}>10</option>
                  <option value={99}>99</option>
                  <option value={188}>188</option>
                  <option value={999}>999</option>
                  <option value={1888}>1888</option>
                  <option value={2999}>2999</option>
                </select>
                <span style={{ color: '#FFD700', fontSize: '10px', position: 'absolute', right: '10px', pointerEvents: 'none' }}>▼</span>
              </div>

              <button 
                onClick={() => { 
                  if (!presenteSelecionado || presenteSelecionado.tipo !== 'lucky') { 
                    alert("Por favor, seleciona primeiro um item Lucky!"); 
                    return; 
                  } 
                  
                  const alvoFinal = utilizadorAlvoId === idDaSalaDestino 
                    ? { uid: idDaSalaDestino, name: dadosDaSala?.donoNome }
                    : participantes.find(p => p && p.uid === utilizadorAlvoId) || { uid: idDaSalaDestino, name: dadosDaSala?.donoNome };

                  processarEnvioPresente({ ...presenteSelecionado, quantidade: quantidadeSelecionada || 1 }, alvoFinal);

                  setMostrarMenuLuckys(false); 
                  setMostrarSelecaoDestinatario(false);
                }} 
                style={{ backgroundColor: '#00B359', color: 'white', border: 'none', padding: '8px 24px', borderRadius: '12px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer', boxShadow: '0 4px 12px rgba(0, 179, 89, 0.3)' }}
              >
                Enviar
              </button>
            </div>

          </div>
        </div>
      )}

    {/* CORTINA DE UTILIZADORES DA BANCADA COM VERIFICAÇÃO ANTECIPADA DE SEGUIDORES */}
      {mostrarLista && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', flexDirection: 'column', padding: '40px 20px', backdropFilter: 'blur(20px)', WebkitBackdropFilter: 'blur(20px)' }}>
          
          {/* MOTOR DE RASTREIO ANTECIPADO: Corre uma vez ao abrir a lista */}
          {(() => {
            if (!window[`init_bancada_seg`]) {
              window[`init_bancada_seg`] = true;
              import('firebase/firestore').then(async ({ collection, getDocs }) => {
                const snapSeg = await getDocs(collection(db, "utilizadores", meuId, "seguindo"));
                const listaIds = snapSeg.docs.map(d => d.id);
                setIdsQueJaSigo(listaIds);
              }).catch((e) => console.error("Erro ao pré-carregar colecao seguindo:", e));
            }
            return null;
          })()}

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px', borderBottom: '1px solid rgba(255, 255, 255, 0.08)', paddingBottom: '12px' }}>
            <h2 style={{ color: '#39FF14', margin: 0, fontSize: '16px', fontWeight: '900', letterSpacing: '1px', textTransform: 'uppercase', textShadow: '0 0 8px rgba(57,255,20,0.3)' }}>BANCADA REAL 🏟️</h2>
            <button onClick={() => { window[`init_bancada_seg`] = false; setMostrarLista(false); }} style={{ background: 'rgba(255,255,255,0.08)', border: 'none', borderRadius: '50%', width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer' }}>✕</button>
          </div>

          <div style={{ flex: 1, overflowY: 'auto' }}>
            {listaAudiencia.map((user) => {
              const souEuProprio = user.uid === meuId;
              const jaSigoEste = idsQueJaSigo?.includes(user.uid) || false;

              return (
                <div 
                  key={user.uid}
                  style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'space-between', 
                    padding: '12px 16px', 
                    marginBottom: '10px', 
                    background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0.01) 100%)',
                    border: '1px solid rgba(255, 255, 255, 0.06)',
                    borderRadius: '16px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                    boxSizing: 'border-box'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <img src={user.foto || FOTO_ADEPTO_PADRAO} alt="Perfil" style={{ width: '40px', height: '40px', borderRadius: '50%', border: '1.5px solid #39FF14', objectFit: 'cover', boxShadow: '0 2px 6px rgba(0,0,0,0.3)' }} />
                    <span style={{ color: 'white', fontWeight: '800', fontSize: '14px', letterSpacing: '0.5px' }}>{user.nome}</span>
                  </div>

                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {/* BOTÃO + SEGUIR INTELIGENTE */}
                    {!souEuProprio && !jaSigoEste && (
                      <button
                        onClick={async (e) => {
                          e.stopPropagation();
                          setIdsQueJaSigo(p => [...p, user.uid]);
                          try {
                            const { doc: fDoc, setDoc: fSetDoc, updateDoc: fUpdateDoc, increment: fIncrement, serverTimestamp: fTime } = await import('firebase/firestore');
                            
                            // 1. Grava na lista de quem TU estás a seguir (Subcoleção 'seguindo')
                            await fSetDoc(fDoc(db, "utilizadores", meuId, "seguindo", user.uid), {
                              nome: user.nome || "Craque",
                              data: fTime()
                            });

                            // 2. Incrementa o contador 'seguindoCount' no teu próprio documento de perfil
                            await fUpdateDoc(fDoc(db, "utilizadores", meuId), { seguindoCount: fIncrement(1) }).catch(() => {});

                            // 3. Grava na lista de quem me segue no ALVO puxando do estado reativo seguro e estável da PWA
                            const meuNomeInjetado = dadosUtilizador?.nomeCompleto || dadosUtilizador?.nome || auth.currentUser?.displayName || "Craque";
                            const minhaFotoInjetada = dadosUtilizador?.fotoUrl || dadosUtilizador?.foto || auth.currentUser?.photoURL || FOTO_ADEPTO_PADRAO;

                            await fSetDoc(fDoc(db, "utilizadores", user.uid, "seguidores", meuId), {
                              nome: meuNomeInjetado,
                              fotoUrl: minhaFotoInjetada,
                              data: fTime()
                            });

                            // 4. Incrementa o contador 'seguidoresCount' no documento do criador (Alvo)
                            await fUpdateDoc(fDoc(db, "utilizadores", user.uid), { seguidoresCount: fIncrement(1) }).catch(() => {});
                          } catch (errSeg) {
                            console.error("Erro ao processar rotina de follow na bancada:", errSeg);
                          }
                        }}
                        style={{ backgroundColor: 'rgba(255, 0, 127, 0.15)', color: '#FF007F', border: '1px solid #FF007F', padding: '6px 14px', borderRadius: '20px', fontSize: '11px', fontWeight: '950', cursor: 'pointer', boxShadow: '0 0 8px rgba(255, 0, 127, 0.2)', textTransform: 'uppercase', letterSpacing: '0.5px' }}
                      >
                        + SEGUIR
                      </button>
                    )}

                    {/* BOTÃO EXPULSAR SUPREMO DO DONO */}
                    {souDono && user.uid !== meuId && (
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          expulsarUtilizador(user.uid);
                        }}
                        style={{ backgroundColor: '#FF3131', color: 'white', border: 'none', padding: '7px 14px', borderRadius: '12px', fontSize: '11px', fontWeight: '900', cursor: 'pointer', boxShadow: '0 4px 10px rgba(255, 49, 49, 0.2)', textTransform: 'uppercase', letterSpacing: '0.5px' }}
                      >
                        EXPULSAR
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

    {/* 🌸 BOTÃO FLUTUANTE ROSA: REENVIO RÁPIDO / COMBO EM RAJADA (ESTILO ALII) */}
      {mostrarBolinhaRosa && comboPresenteAtivo && comboDestinatarioAtivo && comboPresenteAtivo.tipoPresente !== 'sticker' && (
        <div 
          onClick={async (e) => {
            e.stopPropagation();

                      // 🎯 Alinhamento Perfeito Alii: Incrementa rigorosamente pelo tamanho do bloco (ex: 10 em 10)
            const passoComboReal = comboPresenteAtivo.quantidade || quantidadeSelecionada || 1;
            const proximoNumeroCombo = (contagemComboCliques || 0) + passoComboReal;
            
            // Atualiza o contador interno da bolinha na mesma frame
            setContagemComboCliques(proximoNumeroCombo);

            // Sincroniza imediatamente o letreiro néon central com o mesmo valor da bolinha
            setListaAvisosFeed(prev => prev.map(item => 
              item.uidRemetente === meuId 
                ? { ...item, quantidadeCombo: proximoNumeroCombo } 
                : item
            ));
            
            // Dispara a transação enviando o bloco fixo para o saldo debitar de 10 em 10 corretamente
            await processarEnvioPresente({ 
              ...comboPresenteAtivo, 
              quantidade: passoComboReal,
              tipo: comboPresenteAtivo.tipo || comboPresenteAtivo.tipoPresente || 'lucky' 
            }, comboDestinatarioAtivo);

            // 2. Reinicia o relógio de 3 segundos para manter a bolinha viva
            if (window.timerComboBancada) clearTimeout(window.timerComboBancada);
            window.timerComboBancada = setTimeout(() => {
              setMostrarBolinhaRosa(false);
              setContagemComboCliques(0);
            }, 3000);
          }}
          style={{
            position: 'fixed',
            bottom: '110px',
            right: '25px',
            backgroundColor: '#FF007F',
            width: '65px',
            height: '65px',
            borderRadius: '50%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 0 15px #FF007F, inset 0 0 8px rgba(255,255,255,0.6)',
            zIndex: 999999,
            cursor: 'pointer',
            border: '2px solid #FFF',
            animation: 'pulse 0.2s ease'
          }}
        >
          {/* Miniatura do item dentro da bolinha */}
          <img 
            src={comboPresenteAtivo.icone} 
            alt="combo" 
            style={{ width: '28px', height: '28px', objectFit: 'contain' }} 
          />
          
          {/* Contador dinâmico acumulador x1, x2, x3... */}
          <span style={{ 
            color: '#FFF', 
            fontSize: '11px', 
            fontWeight: '950', 
            fontFamily: 'monospace', 
            marginTop: '-2px',
            textShadow: '1px 1px 2px #000'
          }}>
            x{contagemComboCliques}
          </span>
        </div>
      )}

      {/* 👥 MODAL DE SELEÇÃO DE DESTINATÁRIO EM VIDRO FUMADO */}
      {mostrarSelecaoDestinatario && (
        <div style={{ 
          position: 'fixed', 
          inset: 0, 
          backgroundColor: 'rgba(0,0,0,0.75)', 
          zIndex: 20000, 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          padding: '20px' 
        }}>
          <div style={{ 
            width: '100%', 
            maxWidth: '300px', 
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.01) 100%)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)', 
            borderRadius: '25px', 
            border: '2px solid #39FF14', 
            boxShadow: '0 12px 40px rgba(0, 0, 0, 0.5), 0 0 20px rgba(57, 255, 20, 0.15)',
            padding: '24px 20px',
            boxSizing: 'border-box'
          }}>
            <h3 style={{ color: 'white', textAlign: 'center', marginBottom: '20px', fontSize: '15px', fontWeight: '900', letterSpacing: '0.5px', textTransform: 'uppercase' }}>PARA QUEM É O PRESENTE? ⚽</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              
                            {/* 🚀 CORREÇÃO 4.1: Dono sempre disponível para receber presentes dos espetadores */}
              {idDaSalaDestino !== meuId && (
                <button 
                  onClick={() => {
                    const idAlvoEfetivo = dadosDaSala?.donoId || idDaSalaDestino;
                    setUtilizadorAlvoId(idAlvoEfetivo);
                    setDestinatarioEscolhido({
                      uid: idAlvoEfetivo,
                      nome: dadosDaSala?.donoNome || "ANFITRIÃO",
                      foto: dadosDaSala?.donoFoto || ""
                    });

                    if (tipoMenuAtivo === "stickers") {
                      setMostrarMenuStickers(true);
                    } else if (tipoMenuAtivo === "luckys") {
                      setMostrarMenuLuckys(true);
                    } else if (tipoMenuAtivo === "mp4") {
                      setMostrarMenuPresentesNormais(true);
                    }

                    setMostrarSelecaoDestinatario(false);
                  }}
                  style={{ padding: '14px', borderRadius: '12px', backgroundColor: 'rgba(255, 255, 255, 0.04)', color: 'white', border: '1px solid #39FF14', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer', transition: 'all 0.2s ease', boxShadow: '0 2px 6px rgba(0,0,0,0.2)' }}
                >
                  🏟️ ANFITRIÃO ({dadosDaSala?.donoNome || "CRAQUE EM DIRETO"})
                </button>
              )}

              {/* 🚀 CORREÇÃO 4.1: Mapeamento seguro dos participantes na bancada */}
              {participantes.filter(p => p !== null && p.uid !== meuId).map((p, idx) => (
                <button 
                  key={idx}
                  onClick={() => {
                    setUtilizadorAlvoId(p.uid);
                    setDestinatarioEscolhido({
                      uid: p.uid,
                      nome: p.nome || "Craque",
                      foto: p.foto || ""
                    });

                    if (tipoMenuAtivo === "stickers") {
                      setMostrarMenuStickers(true);
                    } else if (tipoMenuAtivo === "luckys") {
                      setMostrarMenuLuckys(true);
                    } else if (tipoMenuAtivo === "mp4") {
                      setMostrarMenuPresentesNormais(true);
                    }

                    setMostrarSelecaoDestinatario(false);
                  }}
                  style={{ padding: '14px', borderRadius: '12px', backgroundColor: 'rgba(255, 255, 255, 0.02)', color: 'white', border: '1px solid rgba(255,255,255,0.08)', fontSize: '13px', cursor: 'pointer', transition: 'all 0.2s ease' }}
                >
                  ⚽ {p.nome || `JOGADOR ${idx + 1}`}
                </button>
              ))}

              {idDaSalaDestino === meuId && participantes.filter(p => p !== null && p.uid !== meuId).length === 0 && (
                <p style={{ color: '#888', textAlign: 'center', fontSize: '12px', margin: '10px 0', fontWeight: '500' }}>Não há outros craques na bancada para receber... 🏟️</p>
              )}

              <button 
                onClick={() => {
                  setMostrarSelecaoDestinatario(false);
                  setUtilizadorAlvoId(null);
                }}
                style={{ marginTop: '10px', padding: '10px', color: '#FF4444', background: 'rgba(255, 68, 68, 0.05)', border: 'none', borderRadius: '12px', fontWeight: 'bold', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', cursor: 'pointer' }}
              >
                CANCELAR
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BancadaSala;

